import _, { cloneDeep, get, orderBy, pick, property, set, startCase, unzip } from 'lodash';
import formatCurrency from "format-currency";
import laborRateModal from "../../../common/modals/laborRateModal/laborRateModal.component";
import createProjectModal from "../../../common/modals/createProjectModal/createProjectModal.component";
import fixedFeeBasisModal from "../../../common/modals/fixedFeeBasisModal/fixedFeeBasisModal.component";
import fixedFeeBasisModificationModal from "../../../common/modals/fixedFeeBasisModificationModal/fixedFeeBasisModificationModal.component";
import createLaborCategoryModal from "../../../common/modals/createLaborCategoryModal/createLaborCategoryModal.component";
import viewLaborCategoryModal from "../../../common/modals/viewLaborCategoryModal/viewLaborCategoryModal.component";
import viewChargeCodesModal from "../../../common/modals/viewChargeCodesModal/viewChargeCodesModal.component";
import viewInvoicesModal from "../../../common/modals/viewInvoicesModal/viewInvoicesModal.component";
import editContractInfoModal from "../../../common/modals/editContractInfoModal/editContractInfoModal.component";
import createPOPModal from "../../../common/modals/createPOPModal/createPOPModal.component";
import confirmModal from "../../../common/modals/ConfirmModal/confirmModal.component";
import addFundingObligationModal from "../../../common/modals/addFundingObligationModal/addFundingObligationModal.component";
import fundingObligationImportResultModal from "../../../common/modals/fundingObligationImportResultModal/fundingObligationImportResultModal.component";
import fundingObligationBulkImportModal from "../../../common/modals/fundingObligationBulkImportModal/fundingObligationBulkImportModal.component";

import addSubcontractorToContractModalComponent from "../../../common/modals/addSubcontractorToContractModal/addSubcontractorToContractModal.component";
import moment from "moment";
import XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';


class ContractDetailsController {
  constructor(toastr, $scope, $element, $http, $rootScope, $stateParams, AuthenticationService, $uibModal, $q, $timeout) {
    'ngInject';

    // Attach a bunch of stuff to the controller instance
    Object.assign(this, {
      // injected dependencies
      toastr,
      $scope,
      $element,
      $http,
      $rootScope,
      $stateParams,
      $uibModal,
      $q,
      $timeout,
      contractDocumentBaseUrl: `${$rootScope.apiHost}/api/admin/contracts/${$stateParams.contractId}/documents`,
      getMonth,
      formatDollars,
      startCase
    });


    this.auth = AuthenticationService;

    // Store invoice check flags separately to avoid digest loop issues
    this.invoiceCheckFlags = new Map(); // Map of popRate.id -> {proceeded: boolean, eventTarget: element}
    
    // Store flags for pop rates with paid invoices to prevent editing
    this.paidInvoiceFlags = new Map(); // Map of popRate.id -> boolean (true if has paid invoices)
    
    // Store original rates before xeditable updates them
    this.originalRates = new Map(); // Map of popRate.id -> {originalRate: value, popRate: object}
    this.originalFixedFeeBasisFields = new Map(); // Map of rowId:field -> original value

    // Labor rates filtering and sorting
    this.laborRateFilter = {
      name: ''
    };
    this.laborRateSort = {
      field: 'name',
      reverse: false,
      popId: null // Store PoP ID when sorting by PoP rate
    };

    this.fundingObligationProjects = [];
    this.fundingObligationTableData = [];
    this.fundingObligationFilterrefresh = false;
    this.importingFundingObligations = false;
    this.totalObligatedFunding = null;
    this.directLaborRateMismatches = [];
    this.directLaborRateMismatchesLoaded = false;
    this.scanningDirectLaborRateMismatches = false;
    this.fixingDirectLaborRateMismatchId = null;
    this.directLaborRateMismatchesExpanded = true;
    this.fundingObligationServerTotals = {};
    this.fundingObligationRestUrl = 'admin/contracts/' + $stateParams.contractId + '/funding-obligations';
    this.fundingObligationFilter = {
      periodOfPerformanceId: '0',
      taskOrderId: '0',
      workType: '0',
      clin: '',
      slin: '',
      acrn: '',
      costElement: '0'
    };
    this.fundingWorkTypeOptions = [
      { value: 'COMPLETION', text: 'Completion' },
      { value: 'LEVEL_OF_EFFORT', text: 'Level of Effort' }
    ];
    this.fundingCostElementOptions = [
      { value: 'AWARD_FEE', text: 'Award Fee' },
      { value: 'BASE_FEE', text: 'Base Fee' },
      { value: 'EQUIPMENT', text: 'Equipment' },
      { value: 'FACILITIES', text: 'Facilities' },
      { value: 'FACILITIES_FEE', text: 'Facilities Fee' },
      { value: 'FCCM', text: 'FCCM' },
      { value: 'FIXED_FEE', text: 'Fixed Fee' },
      { value: 'FRINGE', text: 'Fringe' },
      { value: 'GA', text: 'G&A' },
      { value: 'INCENTIVE_FEE', text: 'Incentive Fee' },
      { value: 'LABOR', text: 'Labor' },
      { value: 'MATERIAL_FEE', text: 'Material Fee' },
      { value: 'MATERIALS', text: 'Materials' },
      { value: 'ODC', text: 'ODC' },
      { value: 'OTHER', text: 'Other' },
      { value: 'OVERHEAD', text: 'Overhead' },
      { value: 'TRAVEL', text: 'Travel' },
      { value: 'TRAVEL_FEE', text: 'Travel Fee' }
    ];

    this.projectFilter = {
      name: '',
      status: 'open'
    }

    this.projectRestUrl = 'admin/contracts/'+$stateParams.contractId+'/projects';
    this.projectFilterrefresh = false;
    this.projectTableData = [];

    this.laborCategoryRestUrl = 'admin/contracts/'+$stateParams.contractId+'/laborcategories';
    this.laborCategoryFilterrefresh = false;

    this.laborCategoryFilter = {
      name: ''
    }

    this.fixedFeeBasisList = [];
    this.fixedFeeBasisGroups = [];
    this.fixedFeeBasisGroupsByPop = {};
    this.fixedFeeBasisRowsByPop = {};
    this.activeFeeBasisPopIndex = 0;
    this.selectedFeeBasisPop = null;
    this.activeLaborRatePopIndex = 0;
    this.selectedLaborRatePop = null;

    this.projectColumns = [
      {
        displayName: 'Name',
        value: 'name',
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          return "<a className=\"text-info\" href=\"admin/projects/"+record.id+"\" >"+record.name+"</a>";
        }
      },
      {
        displayName: 'Description',
        value: 'description',
        sortable: true,
        dataType: 'text'
      },
      {
        displayName: 'Start Date',
        value: 'startDate',
        sortable: true,
        sortValue: 'startDate',
        dataType: 'date',
        formatting: function (record) {
          if (!record.periodsOfPerformance || record.periodsOfPerformance.length === 0) {
            if (record.startDate) {
              return moment(record.startDate).format("MMM, DD, YYYY");
            }
            return '(Not Set)';
          }
          
          // Find the earliest start date
          let earliestStart = moment(record.periodsOfPerformance[0].startDate);
          record.periodsOfPerformance.forEach(pop => {
            const popStart = moment(pop.startDate);
            if (popStart.isBefore(earliestStart)) {
              earliestStart = popStart;
            }
          });
          
          return earliestStart.format("MMM, DD, YYYY");
        }
      },
      {
        displayName: 'Completion Date',
        value: 'completionDate',
        sortable: true,
        sortValue: 'completionDate',
        dataType: 'date',
        formatting: function (record) {
          let completionDate = null;
          let formattedDate = '';
          
          if (record.completionDate) {
            completionDate = moment(record.completionDate);
            formattedDate = completionDate.format("MMM, DD, YYYY");
          } else {
            return '(Not Set)';
          }

          // Check if completion date is expired (before today) and project is not closed
          // Only check the direct completionDate field, not periods of performance
          let dateHtml = formattedDate;
          if (record.completionDate && !record.closed) {
            const completionDateDirect = moment(record.completionDate).startOf('day');
            const today = moment().startOf('day');
            if (completionDateDirect.isBefore(today)) {
              dateHtml = '<span class="expired-project-cell"><i class="fa fa-exclamation-triangle" style="color: #dc3545; margin-right: 5px;"></i>' + formattedDate + '</span>';
            }
          }
          
          // Add ATP information if project has an ATP date
          if (record.atpDate) {
            const atpDateFormatted = moment(record.atpDate).format("MMM, DD, YYYY");
            dateHtml += '<br><span style="font-size: 0.9em; color: #666; font-style: italic;">The project is under ATP until ' + atpDateFormatted + '.</span>';
          }
          
          return dateHtml;
        }
      },
      {
        displayName: 'Funding',
        value: 'funding',
        secure: this.auth.hasPermission('PERM_VIEW_PROJECT_FUNDING'),
        sortable: true,
        dataType: 'text',
        formatting: function (record) {
          return '$'+formatCurrency(record.funding);
        }
      },
      {
        displayName: 'Revenue',
        value: 'allTimeRevenue',
        sortable: true,
        secure: this.auth.hasPermission('PERM_VIEW_PROJECT_REVENUE_INFORMATION'),
        dataType: 'text',
        formatting: function (record) {
          return '$'+formatCurrency(record.allTimeRevenue);
        }
      },
      {
        displayName: 'Remaining Funding',
        value: 'remainingFunding',
        sortable: true,
        secure: this.auth.hasPermission('PERM_VIEW_PROJECT_REVENUE_INFORMATION'),
        dataType: 'text',
        formatting: function (record) {
          const remainingFunding = parseFloat(record.remainingFunding) || 0;
          const formattedValue = '$'+formatCurrency(record.remainingFunding);
          if (remainingFunding < 0) {
            return '<span class="negative-funding-cell"><i class="fa fa-exclamation-triangle" style="color: #dc3545; margin-right: 5px;"></i>' + formattedValue + '</span>';
          }
          return formattedValue;
        }
      }
    ];

    let self = this;
    this.projectFilterCriteria = function () {
      let statusParam = '';
      if (self.projectFilter.status === 'open') {
        statusParam = 'status=open';
      } else if (self.projectFilter.status === 'closed') {
        statusParam = 'status=closed';
      } else {
        statusParam = 'status=all';
      }
      return statusParam + "&name=" + encodeURIComponent(self.projectFilter.name);
    }

    this.laborCategoryFilterCriteria = function () {
      return "name="+encodeURIComponent(self.laborCategoryFilter.name);
    }

    this.fundingObligationFilterCriteria = function () {
      const filter = self.fundingObligationFilter || {};
      const params = [];
      if (filter.periodOfPerformanceId && filter.periodOfPerformanceId !== '0') {
        params.push('periodOfPerformanceId=' + encodeURIComponent(filter.periodOfPerformanceId));
      }
      if (filter.taskOrderId && filter.taskOrderId !== '0') {
        params.push('taskOrderId=' + encodeURIComponent(filter.taskOrderId));
      }
      if (filter.workType && filter.workType !== '0') {
        params.push('workType=' + encodeURIComponent(filter.workType));
      }
      if (filter.clin) {
        params.push('clin=' + encodeURIComponent(filter.clin));
      }
      if (filter.slin) {
        params.push('slin=' + encodeURIComponent(filter.slin));
      }
      if (filter.acrn) {
        params.push('acrn=' + encodeURIComponent(filter.acrn));
      }
      if (filter.costElement && filter.costElement !== '0') {
        params.push('costElement=' + encodeURIComponent(filter.costElement));
      }
      return params.join('&');
    }

    this.onFundingObligationTableResponse = function (response) {
      const total = response
        && response.statistics
        && response.statistics.totalObligatedAmount != null
          ? response.statistics.totalObligatedAmount
          : 0;
      self.fundingObligationServerTotals = {
        obligatedAmount: total
      };
    }

    this.auth = AuthenticationService;

    this.fundingObligationColumns = this.buildFundingObligationColumns();

    this.paymentTermOptions = [
      {value: '15', text: 'Net 15'},
      {value: '30', text: 'Net 30'},
      {value: '45', text: 'Net 45'}
    ];

    this.laborCategoryColumns = [
      {
        displayName: 'Name',
        value: 'name',
        sortable: true,
        dataType: 'text',
        formatting: (record) => {
          const displayText = record.name;
          return `<a class="pull-left" style="cursor: pointer;text-align: left !important;">${displayText}</a>`;
        },
        clickFunction: (record) => {
          this.viewLaborCategory(record);
        }
      },
      {
        displayName: 'Description',
        value: 'description',
        sortable: true,
        dataType: 'text',
        formatting: (record) => {
          if (!record.description) {
            return '';
          }
          
          // Split by sentences (period followed by space or end of string)
          const sentences = record.description.split(/\.\s+/).filter(s => s.length > 0);
          
          // If 2 or fewer sentences, return as is
          if (sentences.length <= 2) {
            return record.description;
          }
          
          // Join first 2 sentences and add periods back, then add "..."
          const firstTwo = sentences.slice(0, 2).join('. ') + '.';
          return firstTwo + '...';
        }
      },
      {
        displayName: 'Qualifications',
        value: 'qualifications',
        sortable: false,
        dataType: 'text',
        formatting: (record) => {
          if (record.requiresDegree) {
            return 'Requires a minimum of ' + record.minimumYearsOfExperienceWithDegree + ' years of experience and a Degree in one of the following diciplines: ' + record.applicableDegrees.map(degree => degree.type + ' ' + degree.discipline).join(', ');
          } else {
            return 'Requires a minimum of ' + record.minimumYearsOfExperienceWithoutDegree + ' years of experience.  No Degree required.';
          }
        }
      },
      {
        displayName: 'Actions',
        value: 'id',
        sortable: false,
        dataType: 'text',
        formatting: (record) => {
          return '<button class="btn btn-danger btn-xs" style="padding: 2px 6px;"><i class="fa-solid fa-trash" style="font-size: 1.1em;"></i></button>';
        },
        clickFunction: (record) => {
          this.deleteLaborCategory(record);
        }
      }
    ];

    this.yesNo = [
      {value: true, text: 'Yes'},
      {value: false, text: 'No'},
    ];

    this.invoiceFrequencyOptions = [
      {value: 'MONTHLY', text: 'Monthly'},
      {value: 'SEMI_MONTHLY', text: 'Semi-Monthly'},
      {value: 'WEEKLY', text: 'Weekly'}
    ];

    this.invoiceMethodOptions = [
      {value: 'MANUAL', text: 'Manual'},
      {value: 'AUTOMATIC', text: 'Automatic'}
    ];

    this.invoiceStructureOptions = [
      {value: 'PER_PROJECT', text: 'One Invoice Per Project'},
      {value: 'PER_CONTRACT', text: 'One Invoice Per Contract'}
    ];

    this.invoiceWeekStartOptions = [
      {value: 'SUNDAY', text: 'Sunday'},
      {value: 'MONDAY', text: 'Monday'}
    ];

    this.timeEntryRoundingIntervalOptions = [
      { value: .1, text: '1/10 of an Hour (6 Minute Intervals)' },
      { value: .25, text: '1/4 of an Hour (15 Minute Intervals)' },
    ]

    this.contractClassOptions = [
      { value: 'prime', text: 'Prime Contract' },
      { value: 'sub', text: 'Subcontract' },
    ]

    this.contractTypeOptions = [
      { value: 'T&M', text: 'Time and Materials' },
      { value: 'FFP', text: 'Firm Fixed Price' },
      { value: 'FFP LOE', text: 'Firm Fixed Price Level of Effort' },
      { value: 'CPFF', text: 'Cost Plus Fixed Fee' },
      { value: 'CPAF', text: 'Cost Plus Award Fee' },
    ]


    $http.get($rootScope.apiHost+"/api/admin/companies/1/degrees", {withCredentials: true}).then(function (success) {
      self.companyDegrees = success.data;
    });

    // load list of customers to back the Customer editable-field
    this.customersPromise = this.loadCustomers().then((customers) => (this.customers = customers));

    // define columns and track current sorting for tables
    // TODO: Figure out which columns should really be shown in each table
    this.tables = {
      projects: {
        columns: ['description', 'funding', 'monthlyRevenue', 'yearlyRevenue', 'allTimeRevenue'],
        sort: { field: 'name', reverse: false }
      },
      lcats: {
        columns: ['name', 'shortName', 'description', "requiresDegree",
        "minimumYearsOfExperienceWithDegree", "minimumYearsOfExperienceWithoutDegree",
      "maximumYearsOfExperienceWithDegree", "maximumYearsOfExperienceWithoutDegree", "applicableDegrees"],
        sort: { field: 'name', reverse: false }
      }
    };

    // toggle the New Period of Performance form
    
    // POP table pagination and sorting
    this.popPageSize = 4;
    this.popCurrentPage = 1;
    this.popSortColumn = 'endDate';
    this.popSortDirection = 'desc';

    // Cached overlapping POPs to prevent infinite digest loops
    this.cachedOverlappingPOPs = [];

    // Method to calculate overlapping periods of performance
    this.calculateOverlappingPOPs = () => {
      if (!this.contract || !this.contract.periodsOfPerformance || this.contract.periodsOfPerformance.length < 2) {
        this.cachedOverlappingPOPs = [];
        return;
      }

      const pops = this.contract.periodsOfPerformance;
      const overlappingPairs = [];
      
      for (let i = 0; i < pops.length; i++) {
        for (let j = i + 1; j < pops.length; j++) {
          const pop1 = pops[i];
          const pop2 = pops[j];
          
          if (!pop1.startDate || !pop1.endDate || !pop2.startDate || !pop2.endDate) {
            continue;
          }

          const start1 = moment(pop1.startDate);
          const end1 = moment(pop1.endDate);
          const start2 = moment(pop2.startDate);
          const end2 = moment(pop2.endDate);

          // Check if periods overlap
          // Two periods overlap if: start1 <= end2 && start2 <= end1
          if (start1.isSameOrBefore(end2, 'day') && start2.isSameOrBefore(end1, 'day')) {
            overlappingPairs.push({ pop1: pop1.name, pop2: pop2.name });
          }
        }
      }
      
      this.cachedOverlappingPOPs = overlappingPairs;
    };

    // Method to get overlapping periods of performance (returns cached result)
    this.getOverlappingPOPs = () => {
      return this.cachedOverlappingPOPs;
    };

    // Method to check if periods of performance have overlapping dates
    this.hasOverlappingPOPs = () => {
      return this.cachedOverlappingPOPs.length > 0;
    };

    // Method to check if there are expired projects (completion date < today and not closed)
    // Only checks the direct completionDate field, not periods of performance
    this.hasExpiredProjects = () => {
      // Since projects are loaded via spring-data-table, we need to check the table data
      // The table data is available through the tabledata binding if provided
      if (this.projectTableData && Array.isArray(this.projectTableData)) {
        const today = moment().startOf('day');
        return this.projectTableData.some(project => {
          if (project.closed || !project.completionDate) {
            return false;
          }
          // Only check the direct completionDate field
          const completionDate = moment(project.completionDate).startOf('day');
          return completionDate.isBefore(today);
        });
      }
      return false;
    };

    this.newLCATModel = {
      name: undefined,
      shortName: undefined,
      description: undefined,
      experience: undefined
    };

    // When labor category is selected, figure out which of the contract's labor rates are associated to it
    this.selectedLcat = null
    this.selectedLcatLaborRates = []
    $scope.$watch(() => this.selectedLcat, (newVal) => {
      if (newVal) {
        const lcatId = newVal.id

        this.selectedLcatLaborRates = this.contract.laborRates.filter(lr => lr.laborCategory.id === lcatId)
          .map(lr => {
            const laborRate = lr
            laborRate.pops = lr.popRates.map(pr => pr.periodOfPerformance.name).join(', ')

            return laborRate
          })
      }
    })

    this.lcatFilter = ''
    this.filteredLcats = []

    $scope.$watch(() => this.lcatFilter, () => {
      this.filterLaborCategories()
    })

    // Do stuff when contract properties change
    $scope.$watch(() => this.contract, (newVal, oldVal) => {
      // Recalculate overlapping POPs when contract changes
      if (newVal) {
        this.calculateOverlappingPOPs();
      }
      const sort = !oldVal && newVal
      this.filterLaborCategories(sort)
    }, true)
  }

  filterLaborCategories(sort) {
    const filterStr = this.lcatFilter+''.trim()

    if (!this.contract || this.contract.laborCategories.length === 0) {
      this.filteredLcats = []
    } else if (!filterStr || filterStr.length === 0) {
      this.filteredLcats = this.contract.laborCategories
    } else {
      this.filteredLcats = this.contract.laborCategories
        .filter(lc => lc.name.toLowerCase().indexOf(filterStr.toLowerCase()) !== -1 || lc.shortName.toLowerCase().indexOf(filterStr.toLowerCase()) !== -1)
    }

    this.filteredLcats = _.sortBy(this.filteredLcats, (lc) => lc.shortName)
  }

  getInvoiceMethodText(value) {
    const option = this.invoiceMethodOptions.find(opt => opt.value === value);
    return option ? option.text : null;
  }

  getInvoiceStructureText(value) {
    const option = this.invoiceStructureOptions.find(opt => opt.value === value);
    return option ? option.text : null;
  }

  getRoundingIntervalText(timeEntryRoundingInterval) {
    let result = 0;

    this.timeEntryRoundingIntervalOptions.forEach(entry => {
      if(entry.value === timeEntryRoundingInterval) {
        result = entry.text;
      }
    });

    return result;
  }

  getContractClassText(contractClass) {
    let result = 0;

    this.contractClassOptions.forEach(entry => {
      if(entry.value === contractClass) {
        result = entry.text;
      }
    });

    return result;
  }

  getContractTypeText(contractType) {
    let result = 0;

    this.contractTypeOptions.forEach(entry => {
      if(entry.value === contractType) {
        result = entry.text;
      }
    });

    return result;
  }



  $postLink() {
    this.contractPromise.then(() => this.handleContract());
    this.alreadyLinked = true;
  }

  updateLaborCategoryForLaborRate(laborRate, laborCategory) {
    // Don't fire REST request if value didn't change
    const originalCategory = laborRate.laborCategory;
    if (originalCategory && laborCategory && originalCategory.id === laborCategory.id) {
      return;
    }
    if (!originalCategory && !laborCategory) {
      return;
    }
    
    laborRate.laborCategory = laborCategory;
    let self = this;
    let attributes = {
    }

    this.$http
      .patch(this.contractUrl + '/laborrates/'+laborRate.id+'/laborcategory/'+laborCategory.id, attributes, { withCredentials: true })
      .then(function (success) {
        self.toastr.success('Successfully updated labor category.', 'SUCCESS');
      })
      .catch((err) => {
        console.error('Could not update labor category:', err);
        this.toastr.error('Could not update labor category.', 'ERROR');
      });

  }


  $onChanges(changes) {
    if (
      changes.contractId &&
      changes.contractId.currentValue !== changes.contractId.previousValue
    ) {

      this.contractPromise = this.loadContract();
      this.contractDocumentBaseUrl = `${this.$rootScope.apiHost}/api/admin/contracts/${this.$stateParams.contractId}/documents`
      if (this.alreadyLinked) {
        this.contractPromise.then(() => this.handleContract());
      }
    }
  }





  deleteLcat(lcatId) {
    let self = this;

    this.$http
      .delete(this.contractUrl + '/laborcategories/'+lcatId, { withCredentials: true })
      .then(function (success) {
        self.toastr.success('Successfully deleted labor category.', 'SUCCESS');
      })
      .catch((err) => {
        console.error('Could not delete labor category:', err);
        this.toastr.error('Could not delete labor category.', 'ERROR');
      });
  }

  getEmployeeDirectLaborInfo(laborRate, userId) {
    let self = this;
    // if(laborRate.directRate) {
    //   self.$http.get(self.$rootScope.apiHost+"/api/admin/users/"+userId, {withCredentials: true}).then(function (user) {
    //     self.uuuu = user;
    //     console.log(user);
    //   });
    // }
  }


  loadContract() {
    this.loadingContract = true;
    let self = this;
    this.contractUrl =
      this.$rootScope.apiHost + '/api/admin/contracts/' + this.$stateParams.contractId;
    return this.$http
      .get(this.contractUrl, {
        withCredentials: true
      })
      .then((res) => {
        this.contract = res.data;

        if(this.contract.startDate) {
          this.contract.startDate = localDate(this.contract.startDate);
        }

        if(this.contract.endDate) {
          this.contract.endDate = localDate(this.contract.endDate);
        }

        this.initLaborRates();
        this.initPOPModel();
        this.initLCATModel();

        if (this.isCostBasedContract()) {
          this.initLaborRatePopTab();
          this.loadFixedFeeBasis();
          this.initFeeBasisPopTab();
          this.applyLaborRateDeleteMetadata();
        }

        this.contractModel = pick(this.contract, [
          'contractName',
          'shortName',
          'customerId',
          'startDate',
          'endDate',
          'primeContractNumber',
          'subContractNumber',
          'netPaymentTerms',
          'invoiceFrequency',
          'invoiceWeekStart',
          'invoiceMethod',
          'invoiceStructure',
          'invoicingCertificationStatement',
          'invoiceSendMethod',
          'invoiceEmailAddress',
          'primeHandlesInvoices',
          'primeInvoiceSystem',
          'primeInvoiceEntryFrequency',
          'timeEntryRoundingInterval',
          'dualTimeEntryRequired',
          'primeTimekeepingSystem',
          'contractClass',
          'contractType',
          'contractFeePercentage',
          'mhRateForOdcs',
          'subcontractManagementFeePercentage',
          'allowSubcontracting'
        ]);
        
        // Initialize selectedCustomer for the dropdown after customers are loaded
        this.selectedCustomer = null;
        this.customersPromise.then(() => {
          if (this.contract.customerId && this.customers) {
            this.selectedCustomer = this.customers.find(c => c.id === this.contract.customerId);
          }
        });

        this.loadingContract = false;
      });
  }

  loadCustomers() {
    return this.$http
      .get(this.$rootScope.apiHost + '/api/admin/customers', {
        withCredentials: true
      })
      .then(property('data'));
  }

  // addSubcontractorToContract() {
  //   let self = this;
  //   var modalInstance = this.$uibModal.open(addSubcontractorToContractModalComponent);
  //
  //   modalInstance.success = function (subcontractor) {
  //     console.log(subcontractor)
  //
  //     self.$http.post(self.contractUrl + '/subcontractors', subcontractor, { withCredentials: true })
  //       .then(function (success) {
  //         self.toastr.success('Successfully added Subcontractor.', 'SUCCESS');
  //       })
  //       .catch((err) => {
  //         console.error('Could not add Subcontractor:', err);
  //         this.toastr.error('Could not add Subcontractor.', 'ERROR');
  //       });
  //
  //     modalInstance.dismiss();
  //   };
  //
  //   modalInstance.cancel = function () {
  //     modalInstance.dismiss();
  //   };
  // }


  onCustomerSelected(customer) {
    if (customer) {
      this.updateContractDetail('customerId', customer.id);
    } else {
      // If customer is cleared, don't update (keep current)
      this.selectedCustomer = this.customers.find(c => c.id === this.contract.customerId);
    }
  }
  
  openEditContractInfoModal() {
    if (!this.checkXEditPermission('PERM_MANAGE_CONTRACT_DETAILS')) {
      return;
    }
    
    let self = this;
    
    // Debug: Log what we're about to pass
    console.log('openEditContractInfoModal - Current values:', {
      contractModel: self.contractModel,
      contract: self.contract,
      contractModelContractName: self.contractModel ? self.contractModel.contractName : 'undefined',
      contractContractName: self.contract ? self.contract.contractName : 'undefined',
      contractModelShortName: self.contractModel ? self.contractModel.shortName : 'undefined',
      contractShortName: self.contract ? self.contract.shortName : 'undefined',
      contractModelCustomerId: self.contractModel ? self.contractModel.customerId : 'undefined',
      contractCustomerId: self.contract ? self.contract.customerId : 'undefined',
      customersLength: self.customers ? self.customers.length : 0
    });
    
    let modalConfig = {
      template: editContractInfoModal.template,
      controller: editContractInfoModal.controller,
      controllerAs: '$ctrl',
      size: 'md',
      windowClass: "hmodal-info animated zoomIn",
      resolve: {
        contractName: function() {
          const value = (self.contractModel && self.contractModel.contractName) || (self.contract && self.contract.contractName) || '';
          console.log('Resolving contractName:', value);
          return value;
        },
        shortName: function() {
          const value = (self.contractModel && self.contractModel.shortName) || (self.contract && self.contract.shortName) || '';
          console.log('Resolving shortName:', value);
          return value;
        },
        customerId: function() {
          const value = (self.contractModel && self.contractModel.customerId) || (self.contract && self.contract.customerId) || null;
          console.log('Resolving customerId:', value);
          return value;
        },
        customers: function() {
          const value = self.customers || [];
          console.log('Resolving customers:', value.length);
          return value;
        },
        contractUrl: function() {
          return self.contractUrl;
        }
      }
    };
    
    var modalInstance = this.$uibModal.open(modalConfig);
    
    modalInstance.result.then(function(result) {
      // Update local models with returned values
      if (result.contractName) {
        self.contractModel.contractName = result.contractName;
        self.contract.contractName = result.contractName;
      }
      if (result.shortName) {
        self.contractModel.shortName = result.shortName;
        self.contract.shortName = result.shortName;
      }
      if (result.customerId) {
        self.contractModel.customerId = result.customerId;
        self.contract.customerId = result.customerId;
        if (result.customerName) {
          self.contract.customerName = result.customerName;
        }
        // Update selectedCustomer
        self.selectedCustomer = self.customers.find(c => c.id === result.customerId);
      }
      self.toastr.success('Contract information updated successfully.', 'SUCCESS');
    }, function() {
      // Modal was dismissed
    });
  }
  
  updateContractDetail(field, value) {
    // none of the details fields are nullable, so an empty value should be
    // treated as a "Cancel" operation and reset the model
    if (value === undefined || value === null) {
      this.contractModel[field] = this.contract[field];
      // Reset selectedCustomer if customerId was cancelled
      if (field === 'customerId') {
        this.selectedCustomer = this.customers.find(c => c.id === this.contract.customerId);
      }
      return;
    }

    // don't bother PATCHing if the value hasn't changed
    if (this.contract[field] && value.toString() === this.contract[field].toString()) {
      return;
    }
    
    // If contractClass is being changed to 'prime', clear subContractNumber
    // But only include it in updates if it actually has a value to clear
    let updates = { [field]: value };
    if (field === 'contractClass' && value === 'prime') {
      // Only clear subContractNumber if it currently has a value (not already empty)
      const currentSubContractNumber = this.contract.subContractNumber || '';
      if (currentSubContractNumber !== '') {
        updates.subContractNumber = '';
      }
    }
    
    const promise = this.$http
      .patch(this.contractUrl, updates, { withCredentials: true })
      .then(() => {
        this.toastr.success('Successfully updated contract details.', 'SUCCESS');

        this.contract[field] = value;
        
        // If contractClass was changed to 'prime', clear subContractNumber locally
        if (field === 'contractClass' && value === 'prime') {
          this.contractModel.subContractNumber = '';
          this.contract.subContractNumber = '';
        }

        if (field === 'contractClass') {
          this.contractModel.contractClass = value;
          if (this.isPrimeContract()) {
            this.refreshFundingObligationFilters();
            this.loadFundingObligationProjects();
            this.fundingObligationFilterrefresh = true;
            this.loadTotalObligatedFunding();
          } else {
            this.fundingObligationProjects = [];
            this.fundingObligationTableData = [];
            this.totalObligatedFunding = null;
          }
        }

        // if customerId was updated, locally update customerName and selectedCustomer after successful PATCH
        if (field === 'customerId') {
          const customer = this.customers.find((c) => c.id === value);
          if (customer) {
            this.contract.customerName = customer.name;
            this.selectedCustomer = customer;
          }
        }
      })
      .catch((err) => {
        console.error('Could not update contract details:', err);
        this.toastr.error('Could not update contract details.', 'ERROR');
        // reset form model to previous value
        this.contractModel[field] = this.contract[field];
      });

    return promise;
  }

  deletePOP(pop) {
    if (!this.checkXEditPermission('PERM_MANAGE_CONTRACT_DETAILS')) {
      return;
    }

    const popId = pop.id;
    const popName = pop.name;
    const deleteUrl = `${this.$rootScope.apiHost}/api/admin/contracts/${this.$stateParams.contractId}/pops/${popId}`;

    this.$http
      .delete(deleteUrl, { withCredentials: true })
      .then(() => {
        // Success - reload contract data to refresh POPs list
        this.toastr.success(`Period of Performance "${popName}" deleted successfully.`, 'Success');
        this.loadContract().then(() => {
          this.initPOPModel();
        });
      })
      .catch((error) => {
        if (error.status === 409) {
          // CONFLICT - PopRates exist
          this.toastr.error(`Cannot delete Period of Performance "${popName}" because it has existing labor rates.`, 'Cannot Delete');
        } else if (error.status === 404) {
          // NOT_FOUND - PeriodOfPerformance doesn't exist
          this.toastr.error(`Period of Performance "${popName}" not found.`, 'Error');
        } else {
          // Other errors (500, etc.)
          this.toastr.error(`Failed to delete Period of Performance "${popName}".`, 'Error');
        }
      });
  }

  handleContract() {
    // this.initLaborRates();
    this.initPOPModel();
    this.initLCATModel();
    if (this.isPrimeContract()) {
      this.refreshFundingObligationFilters();
      this.loadFundingObligationProjects();
      this.fundingObligationFilterrefresh = true;
      this.loadTotalObligatedFunding();
    } else {
      this.fundingObligationProjects = [];
      this.fundingObligationTableData = [];
      this.totalObligatedFunding = null;
    }
    this.loadDirectLaborRateMismatches();
  }

  loadDirectLaborRateMismatches() {
    this.directLaborRateMismatches = [];
    this.directLaborRateMismatchesLoaded = false;
    if (!this.isCostBasedContract()
        || !this.auth.hasPermission('PERM_VIEW_CONTRACT_RATES')
        || !this.$stateParams.contractId) {
      return this.$q.when([]);
    }

    return this.$http.get(
      `${this.$rootScope.apiHost}/api/admin/contracts/${this.$stateParams.contractId}/direct-labor-rate-mismatches`,
      { withCredentials: true }
    ).then((success) => {
      this.directLaborRateMismatches = success.data || [];
      this.directLaborRateMismatchesLoaded = true;
      return this.directLaborRateMismatches;
    }, () => {
      this.directLaborRateMismatches = [];
      this.directLaborRateMismatchesLoaded = true;
      return [];
    });
  }

  runDirectLaborRateMismatchScan() {
    if (!this.auth.hasPermission('PERM_MANAGE_CONTRACT_RATES') || this.scanningDirectLaborRateMismatches) {
      return;
    }
    this.scanningDirectLaborRateMismatches = true;
    this.$http.post(
      `${this.$rootScope.apiHost}/api/admin/jobs/direct-labor-rate-mismatch-scan`,
      {},
      { withCredentials: true }
    ).then((success) => {
      const result = success.data || {};
      const openCount = result.openCount != null ? result.openCount : 0;
      this.toastr.success(
        `DL rate check complete. ${openCount} open issue(s).`,
        'Scan Complete'
      );
      return this.loadDirectLaborRateMismatches();
    }, (failure) => {
      const message = (failure && failure.data && failure.data.message)
        || 'Failed to run Direct Labor Rate mismatch scan';
      this.toastr.error(message, 'ERROR');
    }).finally(() => {
      this.scanningDirectLaborRateMismatches = false;
    });
  }

  canFixDirectLaborRateMismatch(issue) {
    return !!issue
      && this.auth.hasPermission('PERM_MANAGE_CONTRACT_RATES')
      && Math.abs(Number(issue.billingImpactAmount) || 0) < 0.005;
  }

  fixDirectLaborRateMismatch(issue) {
    if (!this.canFixDirectLaborRateMismatch(issue) || this.fixingDirectLaborRateMismatchId) {
      return;
    }
    this.fixingDirectLaborRateMismatchId = issue.id;
    this.$http.post(
      `${this.$rootScope.apiHost}/api/admin/contracts/${this.$stateParams.contractId}/direct-labor-rate-mismatches/${issue.id}/fix`,
      {},
      { withCredentials: true }
    ).then(() => {
      this.toastr.success(
        `Updated DL rate for ${issue.employeeName || 'employee'} to ${this.formatDollars(issue.employeeDirectRate)}.`,
        'Fixed'
      );
      return this.$q.all([
        this.loadDirectLaborRateMismatches(),
        this.loadContract()
      ]);
    }, (failure) => {
      const message = (failure && failure.data && failure.data.message)
        || 'Failed to fix Direct Labor Rate mismatch';
      this.toastr.error(message, 'ERROR');
    }).finally(() => {
      this.fixingDirectLaborRateMismatchId = null;
    });
  }

  isPrimeContract() {
    const contractClass = (this.contractModel && this.contractModel.contractClass)
      || (this.contract && this.contract.contractClass);
    return contractClass === 'prime';
  }

  getDisplayedTotalFunding() {
    if (this.isPrimeContract() && this.totalObligatedFunding != null) {
      return Number(this.totalObligatedFunding) || 0;
    }
    return Number(this.contract && this.contract.funding) || 0;
  }

  getFundedBacklog() {
    return this.getDisplayedTotalFunding() - (Number(this.contract && this.contract.allTimeRevenue) || 0);
  }

  loadTotalObligatedFunding() {
    if (!this.isPrimeContract() || !this.$stateParams.contractId) {
      this.totalObligatedFunding = null;
      return this.$q.when(null);
    }

    return this.$http.get(this.getFundingObligationsUrl(), {
      params: { page: 0, size: 1 },
      withCredentials: true
    }).then((success) => {
      const statistics = success.data && success.data.statistics;
      this.totalObligatedFunding = statistics && statistics.totalObligatedAmount != null
        ? statistics.totalObligatedAmount
        : 0;
      return this.totalObligatedFunding;
    }, () => {
      // Fall back to contract.funding in the widget if obligations cannot be loaded.
      this.totalObligatedFunding = null;
      return null;
    });
  }

  getFundingObligationsUrl() {
    return `${this.$rootScope.apiHost}/api/admin/contracts/${this.$stateParams.contractId}/funding-obligations`;
  }

  buildFundingObligationColumns() {
    const self = this;
    const canManage = this.auth.hasPermission('PERM_MANAGE_PROJECT_FUNDING_DETAILS');

    const columns = [
      {
        displayName: 'Option Year',
        value: 'periodOfPerformanceName',
        sortValue: 'periodOfPerformanceName',
        sortable: true,
        dataType: 'text',
        filterable: true,
        filterOptions: [{ id: 0, name: 'All', label: 'All', selected: true }],
        filterFunction: function (column) {
          self.applySingleSelectFundingFilter(column, 'periodOfPerformanceId');
        }
      },
      {
        displayName: 'Task Order',
        value: 'taskOrderName',
        sortValue: 'taskOrderName',
        sortable: true,
        dataType: 'text',
        filterable: true,
        filterOptions: [{ id: 0, name: 'All', label: 'All', selected: true }],
        filterFunction: function (column) {
          self.applySingleSelectFundingFilter(column, 'taskOrderId');
        },
        formatting: function (record) {
          if (!record.taskOrderId) {
            return record.taskOrderName || '';
          }
          return '<a href="admin/projects/' + record.taskOrderId + '">' + (record.taskOrderName || '') + '</a>';
        }
      },
      {
        displayName: 'Type of Work',
        value: 'workType',
        sortable: true,
        dataType: 'text',
        filterable: true,
        filterOptions: [
          { id: 0, name: 'All', label: 'All', selected: true }
        ].concat(self.fundingWorkTypeOptions.map(function (option) {
          return { id: option.value, name: option.text, label: option.text, selected: true };
        })),
        filterFunction: function (column) {
          self.applySingleSelectFundingFilter(column, 'workType');
        },
        formatting: function (record) {
          return self.getFundingWorkTypeLabel(record.workType);
        }
      },
      {
        displayName: 'Funding Basis',
        value: 'fundingBasis',
        sortable: true,
        dataType: 'text',
        formatting: function (record) {
          return self.getFundingBasisLabel(record.fundingBasis);
        }
      },
      {
        displayName: 'CLIN',
        value: 'clin',
        sortable: true,
        dataType: 'text'
      },
      {
        displayName: 'SLIN',
        value: 'slin',
        sortable: true,
        dataType: 'text',
        formatting: function (record) {
          return record.slin || '—';
        }
      },
      {
        displayName: 'ACRN',
        value: 'acrn',
        sortable: true,
        dataType: 'text'
      },
      {
        displayName: 'Cost Element',
        value: 'costElement',
        sortable: true,
        dataType: 'text',
        filterable: true,
        filterOptions: [
          { id: 0, name: 'All', label: 'All', selected: true }
        ].concat(self.fundingCostElementOptions.map(function (option) {
          return { id: option.value, name: option.text, label: option.text, selected: true };
        })),
        filterFunction: function (column) {
          self.applySingleSelectFundingFilter(column, 'costElement');
        },
        formatting: function (record) {
          return record.costElementDisplayName || self.getFundingCostElementLabel(record.costElement);
        }
      },
      {
        displayName: 'Basis/Unit of Measure',
        value: 'basisUnitOfMeasure',
        sortable: true,
        dataType: 'text',
        formatting: function (record) {
          return record.basisUnitOfMeasure || '—';
        }
      },
      {
        displayName: 'Obligated Amount',
        value: 'obligatedAmount',
        sortable: true,
        dataType: 'number',
        includeInTotal: true,
        formatting: function (record) {
          return '$' + formatCurrency(record.obligatedAmount || 0);
        }
      }
    ];

    if (canManage) {
      columns.push({
        displayName: '',
        value: 'edit',
        sortable: false,
        dataType: 'text',
        formatting: function () {
          return '<button class="btn btn-default btn-xs" style="padding: 2px 6px;" title="Edit"><i class="fa fa-edit"></i></button>';
        },
        clickFunction: function (record) {
          self.openFundingObligationModal(record);
        }
      });
      columns.push({
        displayName: '',
        value: 'delete',
        sortable: false,
        dataType: 'text',
        formatting: function () {
          return '<button class="btn btn-danger btn-xs" style="padding: 2px 6px;" title="Delete"><i class="fa-solid fa-trash"></i></button>';
        },
        clickFunction: function (record) {
          self.deleteFundingObligation(record);
        }
      });
    }

    return columns;
  }

  applySingleSelectFundingFilter(column, filterKey) {
    const selected = (column.filterOptions || []).filter(function (opt) {
      return opt.selected && opt.id !== 0 && opt.id !== 'all';
    });
    const allOption = (column.filterOptions || []).find(function (opt) {
      return opt.id === 0 || opt.id === 'all';
    });

    if (allOption && allOption.selected) {
      (column.filterOptions || []).forEach(function (opt) {
        opt.selected = true;
      });
      this.fundingObligationFilter[filterKey] = '0';
    } else if (selected.length === 0) {
      if (allOption) {
        allOption.selected = false;
      }
      this.fundingObligationFilter[filterKey] = '-1';
    } else if (selected.length === (column.filterOptions || []).length - 1) {
      if (allOption) {
        allOption.selected = true;
      }
      this.fundingObligationFilter[filterKey] = '0';
    } else if (selected.length === 1) {
      if (allOption) {
        allOption.selected = false;
      }
      this.fundingObligationFilter[filterKey] = String(selected[0].id);
    } else {
      if (allOption) {
        allOption.selected = false;
      }
      this.fundingObligationFilter[filterKey] = String(selected[0].id);
    }

    this.fundingObligationFilterrefresh = true;
  }

  refreshFundingObligationFilters() {
    if (!this.fundingObligationColumns) {
      return;
    }

    const popColumn = this.fundingObligationColumns.find(function (column) {
      return column.value === 'periodOfPerformanceName';
    });
    if (popColumn) {
      const pops = (this.contract && this.contract.periodsOfPerformance) || [];
      popColumn.filterOptions = [{ id: 0, name: 'All', label: 'All', selected: true }].concat(
        pops.map(function (pop) {
          return { id: pop.id, name: pop.name, label: pop.name, selected: true };
        })
      );
    }

    const projectColumn = this.fundingObligationColumns.find(function (column) {
      return column.value === 'taskOrderName';
    });
    if (projectColumn) {
      projectColumn.filterOptions = [{ id: 0, name: 'All', label: 'All', selected: true }].concat(
        (this.fundingObligationProjects || []).map(function (project) {
          return { id: project.id, name: project.name, label: project.name, selected: true };
        })
      );
    }
  }

  loadFundingObligationProjects() {
    if (!this.isPrimeContract()) {
      this.fundingObligationProjects = [];
      return;
    }

    const url = `${this.$rootScope.apiHost}/api/admin/contracts/${this.$stateParams.contractId}/projects?page=0&size=10000&status=all&sort=name,asc&name=%25`;
    this.$http.get(url, { withCredentials: true }).then((success) => {
      const page = success.data || {};
      this.fundingObligationProjects = page.content || [];
      this.refreshFundingObligationFilters();
    }, () => {
      this.fundingObligationProjects = [];
    });
  }

  getFundingWorkTypeLabel(workType) {
    const match = this.fundingWorkTypeOptions.find((option) => option.value === workType);
    return match ? match.text : (workType || '');
  }

  getFundingBasisLabel(fundingBasis) {
    if (fundingBasis === 'ACTUALS') {
      return 'Actuals';
    }
    if (fundingBasis === 'CONTRACT_RATES') {
      return 'Contract Rates';
    }
    return '—';
  }

  getFundingCostElementLabel(costElement) {
    const match = this.fundingCostElementOptions.find((option) => option.value === costElement);
    return match ? match.text : (costElement || '');
  }

  openFundingObligationModal(obligation) {
    const self = this;
    if (!this.auth.hasPermission('PERM_MANAGE_PROJECT_FUNDING_DETAILS')) {
      return;
    }

    const ensureProjects = this.fundingObligationProjects.length
      ? this.$q.when(this.fundingObligationProjects)
      : this.$http.get(
          `${this.$rootScope.apiHost}/api/admin/contracts/${this.$stateParams.contractId}/projects?page=0&size=10000&status=all&sort=name,asc&name=%25`,
          { withCredentials: true }
        ).then((success) => {
          const page = success.data || {};
          this.fundingObligationProjects = page.content || [];
          this.refreshFundingObligationFilters();
          return this.fundingObligationProjects;
        }, () => {
          this.fundingObligationProjects = [];
          return [];
        });

    ensureProjects.then(function (projects) {
      const modalInstance = self.$uibModal.open({
        template: addFundingObligationModal.template,
        controller: addFundingObligationModal.controller,
        controllerAs: '$ctrl',
        size: 'md',
        windowClass: 'hmodal-info animated zoomIn',
        resolve: {
          contractId: function () {
            return self.$stateParams.contractId;
          },
          periodsOfPerformance: function () {
            return (self.contract && self.contract.periodsOfPerformance) || [];
          },
          projects: function () {
            return projects || [];
          },
          workTypeOptions: function () {
            return self.fundingWorkTypeOptions;
          },
          costElementOptions: function () {
            return self.fundingCostElementOptions;
          },
          costBased: function () {
            return self.isCostBasedContract();
          },
          obligation: function () {
            return obligation || null;
          }
        }
      });

      modalInstance.result.then(function () {
        self.fundingObligationFilterrefresh = true;
        self.loadTotalObligatedFunding();
      }, function () {});
    });
  }

  deleteFundingObligation(row) {
    if (!row || !row.id) {
      return;
    }
    if (!window.confirm('Delete this funding obligation line?')) {
      return;
    }

    this.$http.delete(`${this.getFundingObligationsUrl()}/${row.id}`, { withCredentials: true }).then(() => {
      this.toastr.success('Funding obligation deleted', 'SUCCESS');
      this.fundingObligationFilterrefresh = true;
      this.loadTotalObligatedFunding();
    }, (failure) => {
      const message = (failure && failure.data && failure.data.message) || 'Failed to delete funding obligation';
      this.toastr.error(message, 'ERROR');
    });
  }

  downloadFundingObligationTemplate() {
    const self = this;
    const ensureProjects = this.fundingObligationProjects.length
      ? this.$q.when(this.fundingObligationProjects)
      : this.$http.get(
          `${this.$rootScope.apiHost}/api/admin/contracts/${this.$stateParams.contractId}/projects?page=0&size=10000&status=all&sort=name,asc&name=%25`,
          { withCredentials: true }
        ).then((success) => {
          const page = success.data || {};
          this.fundingObligationProjects = page.content || [];
          return this.fundingObligationProjects;
        }, () => []);

    ensureProjects.then(function (projects) {
      const header = [
        'Option Year',
        'Task Order',
        'Type of Work',
        'CLIN',
        'SLIN',
        'ACRN',
        'Cost Element',
        'Basis/Unit of Measure',
        'Obligated Amount'
      ];

      const samplePop = ((self.contract && self.contract.periodsOfPerformance) || [])[0];
      const sampleProject = (projects || [])[0];
      const sampleRow = [
        samplePop ? samplePop.name : '',
        sampleProject ? sampleProject.name : '',
        'Level of Effort',
        '0001',
        '',
        'AA',
        'Labor',
        'Hours',
        10000
      ];

      const workbook = XLSX.utils.book_new();
      const templateSheet = XLSX.utils.aoa_to_sheet([header, sampleRow]);
      templateSheet['!cols'] = header.map(() => ({ wch: 22 }));
      XLSX.utils.book_append_sheet(workbook, templateSheet, 'Funding Obligations');

      const instructionRows = [
        ['Contract Funding Obligation Import Template'],
        [''],
        ['Instructions'],
        ['1. Fill out one row per funding obligation on the Funding Obligations sheet.'],
        ['2. Option Year must match an existing Period of Performance name for this contract.'],
        ['3. Task Order must match an existing project name and fall within the Option Year dates.'],
        ['4. Type of Work must be Completion or Level of Effort.'],
        ['5. Cost Element must match one of the values listed on the Reference sheet.'],
        ['6. SLIN and Basis/Unit of Measure are optional.'],
        ['7. Upload the completed file using Bulk Import.'],
        ['8. Import is all-or-nothing: if any row fails validation, nothing is imported.']
      ];
      XLSX.utils.book_append_sheet(workbook, XLSX.utils.aoa_to_sheet(instructionRows), 'Instructions');

      const referenceRows = [
        ['Option Years'],
        ['Name', 'Start Date', 'End Date']
      ];
      ((self.contract && self.contract.periodsOfPerformance) || []).forEach(function (pop) {
        referenceRows.push([
          pop.name || '',
          pop.startDate || '',
          pop.endDate || ''
        ]);
      });
      referenceRows.push(['']);
      referenceRows.push(['Task Orders']);
      referenceRows.push(['Name', 'Start Date', 'Completion Date']);
      (projects || []).forEach(function (project) {
        referenceRows.push([
          project.name || '',
          project.startDate || '',
          project.completionDate || ''
        ]);
      });
      referenceRows.push(['']);
      referenceRows.push(['Type of Work Values']);
      self.fundingWorkTypeOptions.forEach(function (option) {
        referenceRows.push([option.text]);
      });
      referenceRows.push(['']);
      referenceRows.push(['Cost Element Values']);
      self.fundingCostElementOptions.forEach(function (option) {
        referenceRows.push([option.text]);
      });

      XLSX.utils.book_append_sheet(workbook, XLSX.utils.aoa_to_sheet(referenceRows), 'Reference');

      const contractName = (self.contractModel && self.contractModel.contractName)
        || (self.contract && self.contract.name)
        || 'contract';
      const safeName = String(contractName).replace(/[^a-zA-Z0-9-_]+/g, '_').substring(0, 60);
      XLSX.writeFile(workbook, `funding-obligations-template_${safeName}_${moment().format('MMDDYYYY')}.xlsx`);
      self.toastr.success('Template downloaded', 'Export Complete');
    });
  }

  openFundingObligationBulkImportModal() {
    const self = this;
    if (!this.auth.hasPermission('PERM_MANAGE_PROJECT_FUNDING_DETAILS') || this.importingFundingObligations) {
      return;
    }

    const modalInstance = this.$uibModal.open({
      template: fundingObligationBulkImportModal.template,
      controller: fundingObligationBulkImportModal.controller,
      controllerAs: '$ctrl',
      size: 'md',
      windowClass: 'hmodal-info animated zoomIn',
      resolve: {
        downloadTemplate: function () {
          return function () {
            self.downloadFundingObligationTemplate();
          };
        }
      }
    });

    modalInstance.result.then(function (file) {
      if (file) {
        self.importFundingObligationFile(file);
      }
    }, function () {
      // dismissed
    });
  }

  importFundingObligationFile(file) {
    if (!file) {
      return;
    }

    this.importingFundingObligations = true;
    const formData = new FormData();
    formData.append('file', file);

    this.$http.post(
      `${this.getFundingObligationsUrl()}/import`,
      formData,
      {
        withCredentials: true,
        headers: { 'Content-Type': undefined },
        transformRequest: angular.identity
      }
    ).then((success) => {
      const result = success.data || {};
      const imported = result.importedCount || 0;
      if (imported > 0) {
        this.toastr.success(`Imported ${imported} funding obligation line(s)`, 'Import Complete');
        this.fundingObligationFilterrefresh = true;
        this.loadTotalObligatedFunding();
      } else {
        this.openFundingObligationImportResultModal(
          'Import Complete',
          'No data rows were found in the spreadsheet.',
          []
        );
      }
    }, (failure) => {
      const result = (failure && failure.data) || {};
      const errors = result.errors || [];
      if (errors.length) {
        this.openFundingObligationImportResultModal(
          'Import Failed',
          'No funding obligations were imported. Fix the errors below and try again.',
          errors
        );
      } else {
        const message = result.message || 'Failed to import funding obligations';
        this.openFundingObligationImportResultModal(
          'Import Failed',
          message,
          []
        );
      }
    }).finally(() => {
      this.importingFundingObligations = false;
    });
  }

  openFundingObligationImportResultModal(title, summary, errors) {
    this.$uibModal.open({
      template: fundingObligationImportResultModal.template,
      controller: fundingObligationImportResultModal.controller,
      controllerAs: '$ctrl',
      size: 'md',
      windowClass: 'hmodal-warning animated zoomIn',
      resolve: {
        title: function () {
          return title;
        },
        summary: function () {
          return summary;
        },
        errors: function () {
          return errors || [];
        }
      }
    });
  }

  initLaborRates() {

    let popsForContract = this.contract.periodsOfPerformance;
    let self = this;

    this.contract.laborRates.forEach(function (laborRate) {
      if (self.isCostBasedContract()) {
        return;
      }

      let missingPops = laborRate.popRates.length < popsForContract.length;

      if(missingPops) {

        let orderedPops = _.sortBy(popsForContract, "startDate");

        let x = [];
        orderedPops.forEach(function (pop) {
          let pppp = _.find(laborRate.popRates, function (r) {
              return r.periodOfPerformance.id === pop.id;
          });

          if(!pppp) {
            let emptyPopRate = {
              id: -1,
              periodOfPerformance: pop,
              rate: undefined
            };

            let priorPop = self.findPriorPop(popsForContract, pop);
            if (priorPop) {
              let priorPopLaborRate = _.find(laborRate.popRates, function (r) {
                return r.periodOfPerformance.id === priorPop.id;
              });

              if (priorPopLaborRate && priorPopLaborRate.rate) {
                emptyPopRate.rate = priorPopLaborRate.rate + (priorPopLaborRate.rate * (priorPop.laborEscalationRate / 100));
                emptyPopRate.suggestedRate = true;
              }
            }

            laborRate.popRates.push(emptyPopRate);
          }
        });
      }

    });

    if (this.isCostBasedContract()) {
      this.attachFixedFeeBasisOptionsToLaborRates();
    }
  }

  hasSuggestedRates(popRates) {
    let hasSuggested = false;
    popRates.forEach(function (popRate) {
      if(popRate.suggestedRate) {
        hasSuggested = true;
      }
    });

    return hasSuggested;
  }

  hasChargeCodes(popRates) {
    if (!popRates || !Array.isArray(popRates)) {
      return false;
    }
    return popRates.some(function (popRate) {
      return popRate.chargeCodes && popRate.chargeCodes.length > 0;
    });
  }

  canDeleteLaborRate(laborRate) {
    if (!laborRate || !this.checkXEditPermission('PERM_MANAGE_CONTRACT_RATES')) {
      return false;
    }

    if (laborRate.deletable === true) {
      return true;
    }

    if (laborRate.deletable === false && laborRate.deleteBlockedReason) {
      return false;
    }

    return !this.hasChargeCodes(laborRate.popRates);
  }

  getLaborRateDeleteBlockedMessage(laborRate) {
    if (laborRate && laborRate.deleteBlockedReason) {
      return laborRate.deleteBlockedReason;
    }

    if (laborRate && this.hasChargeCodes(laborRate.popRates)) {
      return 'This labor rate cannot be deleted because it is associated with charge codes that have billed hours.';
    }

    return 'This labor rate cannot be deleted.';
  }

  getLaborRateDeleteTooltip(laborRate) {
    if (!laborRate) {
      return 'Labor rate is not available for deletion.';
    }

    if (!this.checkXEditPermission('PERM_MANAGE_CONTRACT_RATES')) {
      return 'You do not have permission to manage contract rates.';
    }

    if (this.canDeleteLaborRate(laborRate)) {
      if (laborRate.deleteRequiresChargeCodeConfirmation) {
        const names = (laborRate.chargeCodesToDelete || []).join(', ');
        return 'Delete labor rate and associated charge code(s): ' + names;
      }
      return 'Delete labor rate';
    }

    return this.getLaborRateDeleteBlockedMessage(laborRate);
  }

  applyLaborRateDeleteMetadata() {
    if (!this.contract || !this.contract.laborRates) {
      return;
    }

    this.contract.laborRates.forEach((laborRate) => {
      if (laborRate.deletable === true || laborRate.deleteBlockedReason) {
        return;
      }

      if (!this.hasChargeCodes(laborRate.popRates)) {
        laborRate.deletable = true;
        laborRate.deleteRequiresChargeCodeConfirmation = false;
        laborRate.chargeCodesToDelete = [];
      }
    });
  }

  acceptSuggestedLaborRates(laborRate) {
    let self = this;

    laborRate.popRates.forEach(function (popRate) {
      if(popRate.suggestedRate) {
        self.updateLaborRate(laborRate, popRate, popRate.rate);
      }
    });
  }


  initPOPModel() {
    if (this.contract.periodsOfPerformance) {
      this.popModel = Object.fromEntries(
        this.contract.periodsOfPerformance.map((pop) => {
          const startDate = localDate(pop.startDate);
          const endDate = localDate(pop.endDate);
          return [
            pop.id,
            {
              name: pop.name,
              startDate: startDate,
              endDate: endDate,
              startDateText: startDate ? moment(startDate).format('MMM DD, YYYY') : '',
              endDateText: endDate ? moment(endDate).format('MMM DD, YYYY') : ''
            }
          ];
        })
      );
    } else {
      this.popModel = {};
    }
    // Reset pagination when POP data changes
    this.popCurrentPage = 1;
  }
  
  getPaginatedPOPs() {
    if (!this.contract || !this.contract.periodsOfPerformance) {
      return [];
    }
    
    // Sort the data
    let sorted = [...this.contract.periodsOfPerformance];
    sorted.sort((a, b) => {
      let aVal = a[this.popSortColumn];
      let bVal = b[this.popSortColumn];
      
      // Handle date sorting
      if (this.popSortColumn === 'startDate' || this.popSortColumn === 'endDate') {
        aVal = aVal ? new Date(aVal).getTime() : 0;
        bVal = bVal ? new Date(bVal).getTime() : 0;
      }
      
      // Handle string sorting
      if (typeof aVal === 'string') {
        aVal = aVal.toLowerCase();
        bVal = bVal.toLowerCase();
      }
      
      // Handle number sorting (laborEscalationRate)
      if (this.popSortColumn === 'laborEscalationRate') {
        aVal = aVal || 0;
        bVal = bVal || 0;
      }
      
      if (aVal < bVal) {
        return this.popSortDirection === 'asc' ? -1 : 1;
      }
      if (aVal > bVal) {
        return this.popSortDirection === 'asc' ? 1 : -1;
      }
      return 0;
    });
    
    // Paginate
    const startIndex = (this.popCurrentPage - 1) * this.popPageSize;
    const endIndex = startIndex + this.popPageSize;
    return sorted.slice(startIndex, endIndex);
  }
  
  getPOPTotalPages() {
    if (!this.contract || !this.contract.periodsOfPerformance) {
      return 1;
    }
    return Math.ceil(this.contract.periodsOfPerformance.length / this.popPageSize);
  }
  
  sortPOPs(column) {
    if (this.popSortColumn === column) {
      // Toggle direction
      this.popSortDirection = this.popSortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      // New column, default to ascending
      this.popSortColumn = column;
      this.popSortDirection = 'asc';
    }
    // Reset to first page when sorting changes
    this.popCurrentPage = 1;
  }

  isActivePeriodOfPerformance(pop) {
    if (!pop.startDate || !pop.endDate) {
      return false;
    }
    const now = moment();
    const startDate = moment(pop.startDate);
    const endDate = moment(pop.endDate);
    
    // Check if current date is between start and end date (inclusive)
    return now.isSameOrAfter(startDate, 'day') && now.isSameOrBefore(endDate, 'day');
  }

  getOrderedPeriodsOfPerformance() {
    if (!this.contract || !this.contract.periodsOfPerformance) {
      return [];
    }
    return _.sortBy(this.contract.periodsOfPerformance, 'startDate');
  }

  initFeeBasisPopTab() {
    const pops = this.getOrderedPeriodsOfPerformance();
    if (!pops.length) {
      this.activeFeeBasisPopIndex = 0;
      this.selectedFeeBasisPop = null;
      return;
    }

    const activePop = pops.find((pop) => this.isActivePeriodOfPerformance(pop));
    const defaultPop = activePop || pops[0];
    this.selectedFeeBasisPop = defaultPop;
    this.activeFeeBasisPopIndex = pops.indexOf(defaultPop);
  }

  onFeeBasisPopSelected(pop) {
    this.selectedFeeBasisPop = pop;
  }

  getSelectedFeeBasisPop() {
    if (this.selectedFeeBasisPop) {
      return this.selectedFeeBasisPop;
    }

    const pops = this.getOrderedPeriodsOfPerformance();
    return pops[this.activeFeeBasisPopIndex] || pops[0] || null;
  }

  initLaborRatePopTab() {
    const pops = this.getOrderedPeriodsOfPerformance();
    if (!pops.length) {
      this.activeLaborRatePopIndex = 0;
      this.selectedLaborRatePop = null;
      return;
    }

    const activePop = pops.find((pop) => this.isActivePeriodOfPerformance(pop));
    const defaultPop = activePop || pops[0];
    this.selectedLaborRatePop = defaultPop;
    this.activeLaborRatePopIndex = pops.indexOf(defaultPop);
    if (defaultPop && defaultPop.id) {
      this.laborRateSort.field = 'popRate_' + defaultPop.id;
      this.laborRateSort.popId = defaultPop.id;
      this.laborRateSort.reverse = false;
    }
  }

  onLaborRatePopSelected(pop) {
    this.selectedLaborRatePop = pop;
    if (pop && pop.id) {
      this.laborRateSort.field = 'popRate_' + pop.id;
      this.laborRateSort.popId = pop.id;
      this.laborRateSort.reverse = false;
    }
  }

  getSelectedLaborRatePop() {
    if (this.selectedLaborRatePop) {
      return this.selectedLaborRatePop;
    }

    const pops = this.getOrderedPeriodsOfPerformance();
    return pops[this.activeLaborRatePopIndex] || pops[0] || null;
  }

  getPopRateForLaborRate(laborRate, pop) {
    if (!laborRate || !pop) {
      return null;
    }

    return (laborRate.popRates || []).find((popRate) => {
      return popRate.periodOfPerformance && popRate.periodOfPerformance.id === pop.id;
    }) || null;
  }

  hasLaborRateForPop(laborRate, pop) {
    if (!laborRate || !laborRate.directRate) {
      return false;
    }

    const popRate = this.getPopRateForLaborRate(laborRate, pop);
    if (!popRate || popRate.id <= 0) {
      return false;
    }

    // Direct labor rates are created with empty pop-rate shells for every option year.
    // Only show the row on years that have actually been configured.
    const hasBasis = popRate.fixedFeeBasisId != null && popRate.fixedFeeBasisId !== '';
    const hasRate = popRate.rate != null && popRate.rate !== '' && Number(popRate.rate) > 0;
    return hasBasis || hasRate;
  }
  
  goToPOPPage(page) {
    this.popCurrentPage = page;
  }
  
  prevPOPPage() {
    if (this.popCurrentPage > 1) {
      this.popCurrentPage--;
    }
  }
  
  nextPOPPage() {
    if (this.popCurrentPage < this.getPOPTotalPages()) {
      this.popCurrentPage++;
    }
  }
  initLCATModel() {
    if (this.contract.laborCategories) {
      this.lcatModel = Object.fromEntries(
        this.contract.laborCategories.map((lcat) => [
          lcat.id,
          Object.fromEntries(this.tables.lcats.columns.map((field) => [field, lcat[field] || '']))
        ])
      );
    } else {
      this.lcatModel = {};
    }
  }

  currency(value) {
    if(value) {
      return '$' + formatCurrency(value);
    } else {
      return undefined;
    }
  }

  percentage(value) {
    if(value) {
      return formatCurrency(value) + '%';
    } else {
      return undefined;
    }
  }

  findPriorPop(contractPeriodsOfPerformance, periodOfPerformance) {
    let popPointer = undefined;
    let popPointerDiff = undefined;

    contractPeriodsOfPerformance.forEach(function (pop) {
      let x = moment(pop.endDate).diff(moment(periodOfPerformance.startDate),'DAYS');
      x = Math.abs(x);

      if(!popPointerDiff || x < popPointerDiff) {
        popPointer = pop;
        popPointerDiff = x;
      }
    });

    if(popPointer && popPointer.id !== periodOfPerformance.id) {
      return popPointer;
    }

  }

  calcRateBasedOnEscalation(laborRate, pop) {
    // console.log(laborRate);
    // console.log(pop);
    //get prior pop from laborRate
    let priorPopRate = undefined;
    let popPointer = undefined;
    let popPointerDiff = undefined;
    laborRate.popRates.forEach(function (popRate) {
      let x = moment(popRate.periodOfPerformance.endDate).diff(moment(pop.periodOfPerformance.startDate),'DAYS');
      x = Math.abs(x);

      if(!popPointerDiff || x < popPointerDiff) {
        popPointer = popRate;
        popPointerDiff = x;
      }
    });

    // console.log('pop: ' + popPointer.periodOfPerformance.name + ' cur: ' + pop.periodOfPerformance.name + ' :: ' + popPointerDiff);



    // if(x === 1) {
    //   // console.log('priorPop: ' + popRate.periodOfPerformance.name);
    //   priorPopRate = popRate;

    // }

    if(popPointer && popPointer.rate && popPointer.periodOfPerformance.laborEscalationRate > 0) {
      let newRate = popPointer.rate + (popPointer.rate * (popPointer.periodOfPerformance.laborEscalationRate/100));
      return newRate;
    } else {
      return '(none)'
    }


  }

  checkXEditPermission(permission) {
    let result = false;

    if(this.auth.hasPermission(permission)){
      result = true;
    }

    return result;
  }

  checkPermission(e, permission) {
    if(!this.auth.hasPermission(permission)){
      e.preventDefault();
    }
  }



  activatePOPForm() {
    let self = this;
    let modalConfig = {
      template: createPOPModal.template,
      controller: createPOPModal.controller,
      controllerAs: '$ctrl',
      size: 'md',
      windowClass: "hmodal-info animated zoomIn",
      resolve: {
        contractUrl: function() {
          return self.contractUrl;
        },
        existingPOPs: function() {
          return self.contract && self.contract.periodsOfPerformance ? self.contract.periodsOfPerformance : [];
        }
      }
    };

    var modalInstance = this.$uibModal.open(modalConfig);

    modalInstance.result.then(function(result) {
      // Add the new POP to the contract's periods of performance
      self.contract.periodsOfPerformance.push({
        name: result.name,
        startDate: result.startDate,
        endDate: result.endDate
      });
      // Recalculate overlapping POPs after adding a new one
      self.calculateOverlappingPOPs();
    }, function() {
      // Modal was dismissed
    });
  }
  updatePOPFromText(popId, field, dateText) {
    // Parse the date text (format: MMM DD, YYYY)
    let dateValue = null;
    if (dateText && dateText.trim()) {
      const parsed = moment(dateText, 'MMM DD, YYYY', true);
      if (parsed.isValid()) {
        dateValue = parsed.toDate();
      } else {
        // Try other formats
        const altParsed = moment(dateText);
        if (altParsed.isValid()) {
          dateValue = altParsed.toDate();
        }
      }
    }
    
    if (!dateValue) {
      // Invalid date, reset to original
      const pop = this.contract.periodsOfPerformance.find((pop) => pop.id === popId);
      if (pop && pop[field]) {
        const originalDate = localDate(pop[field]);
        this.popModel[popId][field] = originalDate;
        this.popModel[popId][field + 'Text'] = originalDate ? moment(originalDate).format('MMM DD, YYYY') : '';
      }
      return;
    }
    
    // Update the text property
    this.popModel[popId][field + 'Text'] = dateText;
    
    // Update using the existing updatePOP method
    this.updatePOP(popId, field, dateValue);
  }

  updatePOP(popId, field, value) {
    const pop = this.contract.periodsOfPerformance.find((pop) => pop.id === popId);

    // none of the POP fields are nullable, so an empty value should be
    // treated as a "Cancel" operation and reset the model
    if (!value) {
      this.popModel[popId][field] = pop[field];
      return;
    }

    // Check if the value has actually changed
    let currentValue = pop[field];
    
    // For date fields, compare the ISO string format
    if (field.endsWith('Date')) {
      const currentDateStr = currentValue ? new Date(currentValue).toISOString().slice(0, 10) : '';
      const newDateStr = value ? new Date(value).toISOString().slice(0, 10) : '';
      if (currentDateStr === newDateStr) {
        // Value hasn't changed, don't make REST call
        return;
      }
    } else {
      // For non-date fields, compare string values
      const currentStr = currentValue ? currentValue.toString() : '';
      const newStr = value ? value.toString() : '';
      if (currentStr === newStr) {
        // Value hasn't changed, don't make REST call
        return;
      }
    }

    const promise = this.$http
      .patch(this.contractUrl + '/pops/' + popId, { [field]: value }, { withCredentials: true })
      .then(() => {
        this.toastr.success('Successfully updated period of performamce.', 'SUCCESS');

        // if a date field was updated, pull out just the 'yyyy-MM-dd' segment
        if (field.endsWith('Date')) {
          pop[field] = value.toISOString().slice(0, 10);
          // Update the text property as well
          if (this.popModel[popId]) {
            // value is already a Date object, so we can use it directly
            this.popModel[popId][field] = value;
            this.popModel[popId][field + 'Text'] = moment(value).format('MMM DD, YYYY');
          }
        } else {
          pop[field] = value;
        }
        // Recalculate overlapping POPs after updating
        this.calculateOverlappingPOPs();
      })
      .catch((err) => {
        console.error('Could not update period of performamce:', err);
        this.toastr.error('Could not update period of performamce.', 'ERROR');
        // reset form model to previous value
        this.popModel[popId][field] = pop[field];
      });

    return promise;
  }

  activateLCATForm() {
    if (this.lcatFormActive) {
      return;
    }
    this.newLCATModel = {
      name: undefined,
      shortName: undefined,
      description: undefined,
      experience: undefined
    };
    this.lcatFormActive = true;
  }
  cancelLCATForm() {
    this.lcatFormActive = false;
  }
  submitNewLCAT($event) {
    $event.preventDefault();

    console.log('foo');
    // if the form is not fully filled out, cancel the request
    if (!(this.newLCATModel.name && this.newLCATModel.shortName && this.newLCATModel.description)) {
      console.log('cancelling');
      return;
    }

    this.$http
      .post(this.contractUrl + '/laborcategories', this.newLCATModel, { withCredentials: true })
      .then(() => {
        this.toastr.success('Successfully added labor category.', 'SUCCESS');
        this.contract.laborCategories.push({
          name: this.newLCATModel.name,
          shortName: this.newLCATModel.shortName,
          description: this.newLCATModel.description,
          experience: this.newLCATModel.experience
        });
        this.lcatFormActive = false;
      })
      .catch((err) => {
        console.error('Could not add labor category:', err);
        this.toastr.error('Could not add labor category.', 'ERROR');
      });
  }
  updateLaborCategoryDetails(id, field, value) {
    this.$http
      .patch(
        this.contractUrl + '/laborcategories/' + id,
        { [field]: value },
        { withCredentials: true }
      )
      .then(() => {
        this.toastr.success('Successfully updated Labor Category.', 'SUCCESS');
      })
      .catch((err) => {
        console.error('Could not update Labor Category:', err);
        this.toastr.error('Could not update Labor Category.', 'ERROR');
      });
  }

  sortTable(table, field) {
    const sort = this.tables[table].sort;
    if (sort.field === field) {
      sort.reverse = !sort.reverse;
    } else {
      sort.field = field;
      sort.reverse = false;
    }
  }

  storeOriginalRate(popRate, newValue) {
    // Store the original rate before xeditable updates it
    // Use a Map to avoid modifying the popRate object (which could cause digest loops)
    const popRateId = popRate.id || 'temp_' + Date.now();
    this.originalRates.set(popRateId, {
      originalRate: popRate.rate,
      popRate: popRate
    });
    return true; // Allow xeditable to proceed
  }

  updateLaborRate(laborRate, popRate, newRate, forceUpdate) {
    let self = this;
    
    // Get the original rate that was stored in onbeforesave
    const popRateId = popRate.id || 'temp_' + Date.now();
    const storedData = self.originalRates ? self.originalRates.get(popRateId) : null;
    const originalRate = storedData ? storedData.originalRate : popRate.rate;
    
    // Clean up the stored original rate
    if (self.originalRates) {
      self.originalRates.delete(popRateId);
    }
    
    // Skip comparison if forceUpdate is true (e.g., when accepting suggested rate)
    if (!forceUpdate) {
      // Compare values - handle null/undefined and type conversion
      if (originalRate === newRate) {
        return;
      }
      // Handle numeric comparison (xeditable might convert strings to numbers)
      if (Number(originalRate) === Number(newRate)) {
        return;
      }
      if ((originalRate == null || originalRate === undefined) && (newRate == null || newRate === undefined)) {
        return;
      }
    }
    
    popRate.rate = newRate;

    if (this.isCostBasedContract() && !this.resolvePopRateFixedFeeBasisId(popRate)) {
      this.toastr.warning('Select a fixed fee basis before saving the pop rate.');
      return;
    }

    if(popRate.id < 0) {
      this.$http.post(
        this.$rootScope.apiHost + '/api/admin/contracts/' + this.contract.id + '/laborrates/' + laborRate.id + '/poprates',
        this.buildPopRateSavePayload(popRate),
        { withCredentials: true }
      ).then(function (success) {
        console.log('added pop rate');

        self.$http.get(self.$rootScope.apiHost+"/api/admin/contracts/"+self.contract.id+"/laborrates/"+laborRate.id+"/poprates", {withCredentials: true}).then(function (answer) {
          laborRate.popRates = answer.data;
          self.initLaborRates();
        });

        self.toastr.success('Labor Rate for PoP Successfully Added', 'SUCCESS');
      });
    } else {
      console.log('updating pop rate')
        this.$http.post(
          this.$rootScope.apiHost + '/api/admin/contracts/' + this.contract.id + '/laborrates/' + laborRate.id + '/poprates/' + popRate.id,
          this.buildPopRateSavePayload(popRate),
          { withCredentials: true }
        ).then(function (success) {

          self.$http.get(self.$rootScope.apiHost+"/api/admin/contracts/"+self.contract.id+"/laborrates/"+laborRate.id+"/poprates", {withCredentials: true}).then(function (answer) {
            laborRate.popRates = answer.data;
            self.initLaborRates();
          });

          self.toastr.success('Labor Rate for PoP Successfully Updated', 'SUCCESS');
        });
    }
  }

  getLaborRateHeading() {
    if(this.isCostBasedContract()) {
      return 'Direct Labor Rates';
    } else {
      return 'Labor Rates';
    }
  }

  sortLaborRates(field, popId) {
    const sortKey = popId ? 'popRate_' + popId : field;
    if (this.laborRateSort.field === sortKey) {
      this.laborRateSort.reverse = !this.laborRateSort.reverse;
    } else {
      this.laborRateSort.field = sortKey;
      this.laborRateSort.reverse = false;
      this.laborRateSort.popId = popId || null;
    }
  }

  getLaborRateCardMeta() {
    const model = this.contractModel || {};
    const fee = model.contractFeePercentage != null
      ? model.contractFeePercentage
      : (this.contract && this.contract.contractFeePercentage);
    const feeDisplay = fee != null && fee !== '' ? `${fee}%` : 'Not Set';

    return {
      contractName: model.contractName || (this.contract && this.contract.name) || '',
      customerName: (this.contract && this.contract.customerName) || '',
      primeContractNumber: model.primeContractNumber || '',
      subContractNumber: model.subContractNumber || '',
      contractClass: this.getContractClassText(model.contractClass) || model.contractClass || '',
      contractType: this.getContractTypeText(model.contractType) || model.contractType || '',
      feePercentage: feeDisplay
    };
  }

  getLaborRateCardPopSummaries(pops) {
    return (pops || []).map((pop) => {
      const start = pop.startDate ? moment(pop.startDate).format('MM/DD/YY') : '';
      const end = pop.endDate ? moment(pop.endDate).format('MM/DD/YY') : '';
      const dates = start && end ? `${start} - ${end}` : (start || end || '');
      const escalation = pop.laborEscalationRate != null && pop.laborEscalationRate !== ''
        ? `${formatCurrency(Number(pop.laborEscalationRate))}%`
        : 'Not Set';

      return {
        name: pop.name || 'PoP',
        dates,
        escalation
      };
    });
  }

  getLaborRateCardLeftHeaderRows(meta) {
    const rows = [
      ['Rate Card'],
      ['Contract Name', meta.contractName],
      ['Prime Contractor', meta.customerName],
      ['Prime Contract Number', meta.primeContractNumber]
    ];

    if (meta.subContractNumber) {
      rows.push(['Subcontract Number', meta.subContractNumber]);
    }

    rows.push(
      ['Contract Classification', meta.contractClass],
      ['Contract Type', meta.contractType],
      ['Contract Fee Percentage', meta.feePercentage]
    );

    return rows;
  }

  buildLaborRateCardTable() {
    const pops = this.getOrderedPeriodsOfPerformance();
    const laborRates = this.getFilteredAndSortedLaborRates().slice().sort((a, b) => {
      const aCategory = ((a.laborCategory && a.laborCategory.name) || '').toLowerCase();
      const bCategory = ((b.laborCategory && b.laborCategory.name) || '').toLowerCase();
      if (aCategory < bCategory) {
        return -1;
      }
      if (aCategory > bCategory) {
        return 1;
      }

      const aName = (a.name || '').toLowerCase();
      const bName = (b.name || '').toLowerCase();
      if (aName < bName) {
        return -1;
      }
      if (aName > bName) {
        return 1;
      }
      return 0;
    });

    const headers = ['Labor Category', 'Description'].concat(pops.map((pop) => {
      const start = pop.startDate ? moment(pop.startDate).format('MM/DD/YY') : '';
      const end = pop.endDate ? moment(pop.endDate).format('MM/DD/YY') : '';
      const range = start && end ? ` (${start} - ${end})` : '';
      return `${pop.name || 'PoP'}${range}`;
    }));

    const rows = laborRates.map((laborRate) => {
      const row = [
        (laborRate.laborCategory && laborRate.laborCategory.name) || '',
        laborRate.name || ''
      ];
      pops.forEach((pop) => {
        const popRate = this.getPopRateForLaborRate(laborRate, pop);
        if (popRate && popRate.rate != null && popRate.rate !== '') {
          row.push(Number(popRate.rate));
        } else {
          row.push('');
        }
      });
      return row;
    });

    return { headers, rows, pops };
  }

  getLaborRateCardFileName() {
    const meta = this.getLaborRateCardMeta();
    const safeName = (meta.contractName || 'contract')
      .replace(/[^a-zA-Z0-9-_]+/g, '_')
      .replace(/^_+|_+$/g, '')
      .substring(0, 60) || 'contract';
    return `rate-card_${safeName}_${moment().format('MMDDYYYY')}`;
  }

  exportLaborRateCard(format) {
    if (this.isCostBasedContract()) {
      this.toastr.warning('Rate card export is available for T&M and FFP contracts.', 'Export');
      return;
    }

    const table = this.buildLaborRateCardTable();
    if (!table.rows.length) {
      this.toastr.warning('There are no labor rates to export.', 'Export');
      return;
    }

    if (format === 'pdf') {
      this.exportLaborRateCardPdf(table);
    } else {
      this.exportLaborRateCardExcel(table);
    }
  }

  exportLaborRateCardExcel(table) {
    const meta = this.getLaborRateCardMeta();
    const leftRows = this.getLaborRateCardLeftHeaderRows(meta);
    const popSummaries = this.getLaborRateCardPopSummaries(table.pops);
    const popStartCol = Math.max(4, table.headers.length - 3);
    const colCount = Math.max(table.headers.length, popStartCol + 3);
    const blank = () => new Array(colCount).fill('');

    const headerRowCount = Math.max(leftRows.length, popSummaries.length + 2);
    const sheetRows = [];

    for (let i = 0; i < headerRowCount; i++) {
      const row = blank();

      if (leftRows[i]) {
        leftRows[i].forEach((value, col) => {
          row[col] = value == null ? '' : value;
        });
      }

      if (i === 0) {
        row[popStartCol] = 'Periods of Performance';
      } else if (i === 1) {
        row[popStartCol] = 'Period';
        row[popStartCol + 1] = 'Dates';
        row[popStartCol + 2] = 'Labor Escalation';
      } else {
        const pop = popSummaries[i - 2];
        if (pop) {
          row[popStartCol] = pop.name;
          row[popStartCol + 1] = pop.dates;
          row[popStartCol + 2] = pop.escalation;
        }
      }

      sheetRows.push(row);
    }

    sheetRows.push(blank());
    sheetRows.push(table.headers.concat(blank().slice(table.headers.length)));
    table.rows.forEach((row) => {
      sheetRows.push(row.concat(blank().slice(row.length)));
    });

    const worksheet = XLSX.utils.aoa_to_sheet(sheetRows);
    worksheet['!cols'] = new Array(colCount).fill(null).map((_, index) => {
      if (index < 2) {
        return { wch: 24 };
      }
      if (index >= popStartCol && index < popStartCol + 3) {
        return { wch: index === popStartCol + 1 ? 18 : 16 };
      }
      return { wch: 14 };
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Rate Card');
    XLSX.writeFile(workbook, `${this.getLaborRateCardFileName()}.xlsx`);
    this.toastr.success('Rate card exported successfully', 'Export Complete');
  }

  exportLaborRateCardPdf(table) {
    const meta = this.getLaborRateCardMeta();
    const popSummaries = this.getLaborRateCardPopSummaries(table.pops);
    const orientation = table.headers.length > 6 ? 'l' : 'p';
    const doc = new jsPDF(orientation);
    const pageWidth = doc.internal.pageSize.getWidth();
    const leftX = 14;
    const rightX = Math.max(pageWidth / 2 + 4, pageWidth - 110);
    let yPos = 14;

    doc.setFontSize(14);
    doc.setFontStyle('bold');
    doc.text('Rate Card', leftX, yPos);
    yPos += 8;

    const leftStartY = yPos;
    doc.setFontSize(10);
    doc.setFontStyle('normal');
    const headerLines = [
      `Contract Name: ${meta.contractName || '—'}`,
      `Prime Contractor: ${meta.customerName || '—'}`,
      `Prime Contract Number: ${meta.primeContractNumber || '—'}`,
      `Contract Classification: ${meta.contractClass || '—'}`,
      `Contract Type: ${meta.contractType || '—'}`,
      `Contract Fee Percentage: ${meta.feePercentage || '—'}`
    ];
    if (meta.subContractNumber) {
      headerLines.splice(3, 0, `Subcontract Number: ${meta.subContractNumber}`);
    }

    let leftY = leftStartY;
    headerLines.forEach((line) => {
      doc.text(line, leftX, leftY);
      leftY += 5;
    });

    let rightEndY = leftStartY;
    if (popSummaries.length) {
      doc.setFontStyle('bold');
      doc.text('Periods of Performance', rightX, leftStartY);
      doc.setFontStyle('normal');

      doc.autoTable({
        startY: leftStartY + 2,
        head: [['Period', 'Dates', 'Labor Escalation']],
        body: popSummaries.map((pop) => [pop.name, pop.dates, pop.escalation]),
        theme: 'plain',
        headStyles: { fillColor: [52, 73, 94], textColor: 255, fontStyle: 'bold', fontSize: 8 },
        styles: { fontSize: 8, cellPadding: 1.5, overflow: 'linebreak' },
        margin: { left: rightX, right: 14 },
        tableWidth: pageWidth - rightX - 14
      });
      rightEndY = doc.lastAutoTable.finalY;
    }

    yPos = Math.max(leftY, rightEndY) + 6;

    const body = table.rows.map((row) => row.map((cell, index) => {
      if (index >= 2 && cell !== '' && cell != null && !isNaN(cell)) {
        return this.currency(cell) || '';
      }
      return cell == null ? '' : String(cell);
    }));

    doc.autoTable({
      startY: yPos,
      head: [table.headers],
      body,
      theme: 'striped',
      headStyles: { fillColor: [52, 73, 94], textColor: 255, fontStyle: 'bold' },
      styles: { fontSize: 8, cellPadding: 2, overflow: 'linebreak' },
      columnStyles: {
        0: { cellWidth: 35 },
        1: { cellWidth: 40 }
      },
      margin: { left: 14, right: 14 }
    });

    doc.save(`${this.getLaborRateCardFileName()}.pdf`);
    this.toastr.success('Rate card exported successfully', 'Export Complete');
  }

  getFilteredAndSortedLaborRates(pop) {
    let self = this;
    if (!this.contract || !this.contract.laborRates) {
      return [];
    }

    let filtered = this.contract.laborRates;

    if (pop && this.isCostBasedContract()) {
      filtered = filtered.filter((laborRate) => this.hasLaborRateForPop(laborRate, pop));
    }

    // Apply text filter
    if (this.laborRateFilter.name && this.laborRateFilter.name.trim()) {
      const filterText = this.laborRateFilter.name.toLowerCase().trim();
      filtered = filtered.filter(function(laborRate) {
        const name = (laborRate.name || '').toLowerCase();
        const categoryName = (laborRate.laborCategory && laborRate.laborCategory.name ? laborRate.laborCategory.name : '').toLowerCase();
        const employee = (laborRate.employee || '').toLowerCase();
        return name.indexOf(filterText) !== -1 || 
               categoryName.indexOf(filterText) !== -1 || 
               employee.indexOf(filterText) !== -1;
      });
    }

    // Apply sorting
    const sortField = this.laborRateSort.field;
    const reverse = this.laborRateSort.reverse;
    const popId = this.laborRateSort.popId;
    
    filtered = filtered.sort(function(a, b) {
      let aVal, bVal;
      
      if (sortField.startsWith('popRate_')) {
        // Sorting by PoP rate - find the popRate for the specific PoP
        const aPopRate = (a.popRates || []).find(function(pr) {
          return pr.periodOfPerformance && pr.periodOfPerformance.id === popId;
        });
        const bPopRate = (b.popRates || []).find(function(pr) {
          return pr.periodOfPerformance && pr.periodOfPerformance.id === popId;
        });
        
        aVal = aPopRate && aPopRate.rate != null ? Number(aPopRate.rate) : -Infinity;
        bVal = bPopRate && bPopRate.rate != null ? Number(bPopRate.rate) : -Infinity;
      } else if (sortField === 'name') {
        aVal = (a.name || '').toLowerCase();
        bVal = (b.name || '').toLowerCase();
      } else if (sortField === 'laborCategory') {
        aVal = (a.laborCategory && a.laborCategory.name ? a.laborCategory.name : '').toLowerCase();
        bVal = (b.laborCategory && b.laborCategory.name ? b.laborCategory.name : '').toLowerCase();
      } else if (sortField === 'employee') {
        aVal = (a.employee || '').toLowerCase();
        bVal = (b.employee || '').toLowerCase();
      } else if (sortField === 'indirectRate') {
        aVal = (a.indirectRate && a.indirectRate.name ? a.indirectRate.name : '').toLowerCase();
        bVal = (b.indirectRate && b.indirectRate.name ? b.indirectRate.name : '').toLowerCase();
      } else {
        aVal = a[sortField];
        bVal = b[sortField];
      }

      if (aVal < bVal) {
        return reverse ? 1 : -1;
      }
      if (aVal > bVal) {
        return reverse ? -1 : 1;
      }
      return 0;
    });

    return filtered;
  }

  addFixedFeeBasisEntry() {
    let self = this;
    const selectedPop = this.getSelectedFeeBasisPop();
    if (!selectedPop) {
      this.toastr.warning('No option year is available for adding initial basis.');
      return;
    }

    var modalInstance = this.$uibModal.open(fixedFeeBasisModal);
    modalInstance.laborCategories = this.contract.laborCategories;
    modalInstance.selectedPeriodOfPerformance = selectedPop;
    modalInstance.contractId = this.contract.id;
    modalInstance.existingFixedFeeBasis = this.fixedFeeBasisList || [];

    modalInstance.result.then(function (fixedFeeBasis) {
      self.$http.post(self.contractUrl + '/fixedfeebasis', fixedFeeBasis, { withCredentials: true })
        .then(function () {
          self.toastr.success('Fixed fee basis entry added.', 'SUCCESS');
          self.loadFixedFeeBasis();
        }, function (failure) {
          self.toastr.error((failure.data && failure.data.message) || 'Could not add fixed fee basis entry.', 'ERROR');
        });
    });
  }

  addFixedFeeBasisModification(group) {
    let self = this;
    const openRow = this.getOpenFixedFeeBasisRow(group);

    const modalInstance = this.$uibModal.open(fixedFeeBasisModificationModal);
    modalInstance.groupLabel = (group.popName || 'POP') + ' / ' + (group.laborCategoryName || 'Labor Category');
    modalInstance.periodOfPerformanceId = group.periodOfPerformanceId;
    modalInstance.laborCategoryId = group.laborCategoryId;
    modalInstance.priorBasis = openRow;
    modalInstance.suggestedEffectiveDate = openRow && openRow.effectiveDate
      ? moment(openRow.effectiveDate).add(1, 'day').format('YYYY-MM-DD')
      : null;

    modalInstance.result.then(function (payload) {
      self.$http.post(self.contractUrl + '/fixedfeebasis/modifications', payload, { withCredentials: true })
        .then(function (response) {
          self.loadFixedFeeBasis();
          (response.data.warnings || []).forEach(function (warning) {
            self.toastr.warning(warning);
          });
          self.toastr.success('Fixed fee modification added.', 'SUCCESS');
        }, function (failure) {
          self.toastr.error((failure.data && failure.data.message) || 'Could not add fixed fee modification.', 'ERROR');
        });
    });
  }

  loadFixedFeeBasis() {
    if (!this.isCostBasedContract() || !this.contractUrl) {
      return Promise.resolve();
    }

    return this.$http.get(this.contractUrl + '/fixedfeebasis', { withCredentials: true })
      .then((response) => {
        this.fixedFeeBasisList = response.data || [];
        this.buildFixedFeeBasisGroups();
        this.attachFixedFeeBasisOptionsToLaborRates();
      })
      .catch((err) => {
        console.error('Could not load fixed fee basis:', err);
        this.toastr.error('Could not load fixed fee basis rows.', 'ERROR');
      });
  }

  buildFixedFeeBasisGroups() {
    const groupMap = {};

    (this.fixedFeeBasisList || []).forEach((row) => {
      const key = row.periodOfPerformanceId + ':' + row.laborCategoryId;
      if (!groupMap[key]) {
        groupMap[key] = {
          key: key,
          periodOfPerformanceId: row.periodOfPerformanceId,
          laborCategoryId: row.laborCategoryId,
          laborCategoryName: row.laborCategoryName,
          popName: this.getPopNameById(row.periodOfPerformanceId),
          rows: []
        };
      }
      groupMap[key].rows.push(row);
    });

    this.fixedFeeBasisGroups = Object.values(groupMap).map((group) => {
      group.rows = group.rows.sort((a, b) => (a.effectiveDate || '').localeCompare(b.effectiveDate || ''));
      return group;
    }).sort((a, b) => {
      return (a.laborCategoryName || '').localeCompare(b.laborCategoryName || '');
    });

    this.fixedFeeBasisGroupsByPop = {};
    this.fixedFeeBasisGroups.forEach((group) => {
      if (!this.fixedFeeBasisGroupsByPop[group.periodOfPerformanceId]) {
        this.fixedFeeBasisGroupsByPop[group.periodOfPerformanceId] = [];
      }
      this.fixedFeeBasisGroupsByPop[group.periodOfPerformanceId].push(group);
    });

    this.fixedFeeBasisRowsByPop = {};
    (this.fixedFeeBasisList || []).forEach((row) => {
      if (!this.fixedFeeBasisRowsByPop[row.periodOfPerformanceId]) {
        this.fixedFeeBasisRowsByPop[row.periodOfPerformanceId] = [];
      }
      this.fixedFeeBasisRowsByPop[row.periodOfPerformanceId].push(row);
    });
    Object.keys(this.fixedFeeBasisRowsByPop).forEach((popId) => {
      this.fixedFeeBasisRowsByPop[popId].sort((a, b) => {
        const lcatCompare = (a.laborCategoryName || '').localeCompare(b.laborCategoryName || '');
        if (lcatCompare !== 0) {
          return lcatCompare;
        }
        return (a.effectiveDate || '').localeCompare(b.effectiveDate || '');
      });
    });
  }

  getFixedFeeBasisGroupsForPop(popId) {
    return this.fixedFeeBasisGroupsByPop[popId] || [];
  }

  getFixedFeeBasisRowsForPop(popId) {
    return this.fixedFeeBasisRowsByPop[popId] || [];
  }

  getFixedFeeBasisGroupForRow(row) {
    return _.find(this.fixedFeeBasisGroups, (group) => {
      return group.periodOfPerformanceId === row.periodOfPerformanceId
        && group.laborCategoryId === row.laborCategoryId;
    });
  }

  canAddFixedFeeModificationForRow(row) {
    if (row.expirationDate) {
      return false;
    }
    const group = this.getFixedFeeBasisGroupForRow(row);
    return !!group && this.canAddFixedFeeModification(group);
  }

  canDeleteFixedFeeBasis(row) {
    return !!row && !row.inUse;
  }

  getFixedFeeBasisDeleteTooltip(row) {
    if (this.canDeleteFixedFeeBasis(row)) {
      return 'Delete fee basis';
    }
    return 'Referenced by labor rates';
  }

  deleteFixedFeeBasis(row) {
    if (!this.canDeleteFixedFeeBasis(row)) {
      this.toastr.warning('This fee basis is referenced by labor rates and cannot be deleted.', 'WARNING');
      return;
    }

    let self = this;
    const modalInstance = this.$uibModal.open(confirmModal);
    modalInstance.title = 'Delete Fee Basis';
    modalInstance.subject = (row.laborCategoryName || 'Fee Basis') + (row.modLabel ? ' — ' + row.modLabel : '');
    modalInstance.message = 'Delete this fixed fee basis record permanently?';

    modalInstance.yes = function () {
      modalInstance.dismiss();
      self.$http.delete(self.contractUrl + '/fixedfeebasis/' + row.id, { withCredentials: true })
        .then(function () {
          self.toastr.success('Fee basis deleted.', 'SUCCESS');
          self.loadFixedFeeBasis();
        }, function (failure) {
          const message = failure.data && failure.data.message
            ? failure.data.message
            : 'Could not delete fee basis.';
          self.toastr.error(message, 'ERROR');
        });
    };

    modalInstance.no = function () {
      modalInstance.dismiss();
    };
  }

  getPopNameById(popId) {
    const pop = _.find(this.contract.periodsOfPerformance, { id: popId });
    return pop ? pop.name : '';
  }

  getOpenFixedFeeBasisRow(group) {
    return (group.rows || []).find((row) => !row.expirationDate) || null;
  }

  canAddFixedFeeModification(group) {
    return !!this.getOpenFixedFeeBasisRow(group);
  }

  getFixedFeeBasisStatusLabel(row) {
    if (!row.expirationDate) {
      return row.locked ? 'Current (locked)' : 'Current';
    }
    return 'Historical';
  }

  formatFixedFeeBasisOption(basis) {
    let label = (basis.modLabel || 'Basis') + ' — effective ' + moment(basis.effectiveDate).format('MMM DD, YYYY');
    if (basis.expirationDate) {
      label += ' – ' + moment(basis.expirationDate).format('MMM DD, YYYY');
    }
    return label;
  }

  getFixedFeeBasisOptionsForPopRate(laborRate, pop) {
    const popId = pop.periodOfPerformance && pop.periodOfPerformance.id;
    const laborCategory = pop.laborCategory || laborRate.laborCategory;
    const laborCategoryId = laborCategory && laborCategory.id;
    if (!popId || !laborCategoryId) {
      return [];
    }
    return (this.fixedFeeBasisList || []).filter((basis) => {
      return basis.periodOfPerformanceId === popId && basis.laborCategoryId === laborCategoryId;
    });
  }

  syncPopRateFixedFeeBasisSelection(popRate) {
    if (!popRate) {
      return;
    }

    const options = popRate.availableFixedFeeBasisOptions || [];
    if (popRate.fixedFeeBasisId != null && popRate.fixedFeeBasisId !== '') {
      const basisId = Number(popRate.fixedFeeBasisId);
      popRate.selectedFixedFeeBasis = options.find((basis) => basis.id === basisId) || null;
      popRate.fixedFeeBasisId = basisId;
    } else {
      popRate.selectedFixedFeeBasis = null;
      popRate.fixedFeeBasisId = null;
    }
  }

  attachFixedFeeBasisOptionsToLaborRates() {
    if (!this.isCostBasedContract() || !this.contract || !this.contract.laborRates) {
      return;
    }

    this.contract.laborRates.forEach((laborRate) => {
      (laborRate.popRates || []).forEach((popRate) => {
        popRate.availableFixedFeeBasisOptions = this.getFixedFeeBasisOptionsForPopRate(laborRate, popRate);
        this.syncPopRateFixedFeeBasisSelection(popRate);
      });
    });
  }

  resolvePopRateFixedFeeBasisId(popRate) {
    if (popRate.selectedFixedFeeBasis && popRate.selectedFixedFeeBasis.id != null) {
      return Number(popRate.selectedFixedFeeBasis.id);
    }
    if (popRate.fixedFeeBasisId != null && popRate.fixedFeeBasisId !== '') {
      return Number(popRate.fixedFeeBasisId);
    }
    return null;
  }

  hasPopRateFixedFeeBasis(popRate) {
    return this.resolvePopRateFixedFeeBasisId(popRate) != null;
  }

  canEditPopRateFixedFeeBasis(popRate) {
    if (!this.isCostBasedContract()) {
      return false;
    }
    return !this.hasPopRateFixedFeeBasis(popRate);
  }

  getPopRateFixedFeeBasisLabel(popRate) {
    if (popRate.fixedFeeModLabel) {
      return popRate.fixedFeeModLabel;
    }
    if (popRate.selectedFixedFeeBasis) {
      return this.formatFixedFeeBasisOption(popRate.selectedFixedFeeBasis);
    }
    const basisId = popRate.fixedFeeBasisId != null ? Number(popRate.fixedFeeBasisId) : null;
    if (basisId && popRate.availableFixedFeeBasisOptions) {
      const basis = popRate.availableFixedFeeBasisOptions.find((row) => row.id === basisId);
      if (basis) {
        return this.formatFixedFeeBasisOption(basis);
      }
    }
    return '—';
  }

  getLaborIndirectRates(laborRate) {
    const indirect = laborRate && laborRate.indirectRate;
    return {
      fringeRate: indirect ? Number(indirect.fringeRate) || 0 : 0,
      overheadRate: indirect ? Number(indirect.overheadRate) || 0 : 0,
      generalAdministrativeRate: indirect ? Number(indirect.generalAdministrativeRate) || 0 : 0
    };
  }

  getPopRateDirectRate(popRate) {
    return Number(popRate && popRate.rate) || 0;
  }

  getPopRateFringeRate(laborRate) {
    return this.getLaborIndirectRates(laborRate).fringeRate;
  }

  getPopRateOverheadRate(laborRate) {
    return this.getLaborIndirectRates(laborRate).overheadRate;
  }

  getPopRateGeneralAdministrativeRate(laborRate) {
    return this.getLaborIndirectRates(laborRate).generalAdministrativeRate;
  }

  getPopRateFringeAmount(laborRate, popRate) {
    return this.getPopRateDirectRate(popRate) * (this.getPopRateFringeRate(laborRate) / 100);
  }

  getPopRateFringeSubtotal(laborRate, popRate) {
    return this.getPopRateDirectRate(popRate) + this.getPopRateFringeAmount(laborRate, popRate);
  }

  getPopRateOverheadAmount(laborRate, popRate) {
    return this.getPopRateFringeSubtotal(laborRate, popRate) * (this.getPopRateOverheadRate(laborRate) / 100);
  }

  getPopRateOverheadSubtotal(laborRate, popRate) {
    return this.getPopRateFringeSubtotal(laborRate, popRate) + this.getPopRateOverheadAmount(laborRate, popRate);
  }

  getPopRateGeneralAdministrativeAmount(laborRate, popRate) {
    return this.getPopRateOverheadSubtotal(laborRate, popRate) * (this.getPopRateGeneralAdministrativeRate(laborRate) / 100);
  }

  getPopRateFullyBurdenedRateAmount(laborRate, popRate) {
    if (popRate.fullyBurdenedRate != null && Number(popRate.fullyBurdenedRate) > 0) {
      return Number(popRate.fullyBurdenedRate);
    }
    return this.getPopRateOverheadSubtotal(laborRate, popRate) + this.getPopRateGeneralAdministrativeAmount(laborRate, popRate);
  }

  getPopRateFullyBurdenedInclusiveOfFee(laborRate, popRate) {
    if (popRate && popRate.fullyBurdenedRateInclusiveOfFee != null && Number(popRate.fullyBurdenedRateInclusiveOfFee) > 0) {
      return Number(popRate.fullyBurdenedRateInclusiveOfFee);
    }
    return this.getPopRateFullyBurdenedRateAmount(laborRate, popRate) + this.getPopRateFeeAmount(laborRate, popRate);
  }

  getPopRateFeeAmount(laborRate, popRate) {
    if (popRate.feeRate != null && popRate.feeRate !== '' && this.hasPopRateFixedFeeBasis(popRate)) {
      return Number(popRate.feeRate);
    }

    const basisId = this.resolvePopRateFixedFeeBasisId(popRate);
    if (basisId && this.fixedFeeBasisList) {
      const basis = this.fixedFeeBasisList.find((row) => row.id === basisId);
      if (basis && basis.fixedFeePerHour != null) {
        return Number(basis.fixedFeePerHour);
      }
    }

    const fullyBurdened = this.getPopRateFullyBurdenedRateAmount(laborRate, popRate);
    const feePct = this.contract && this.contract.contractFeePercentage != null
      ? Number(this.contract.contractFeePercentage)
      : 0;
    return fullyBurdened * (feePct / 100);
  }

  formatRatePercent(value) {
    return formatCurrency(Number(value) || 0);
  }

  buildPopRateSavePayload(popRate) {
    const payload = {
      rate: popRate.rate,
      periodOfPerformance: {
        id: popRate.periodOfPerformance.id
      }
    };

    if (popRate.id > 0) {
      payload.id = popRate.id;
    }

    if (this.isCostBasedContract()) {
      const fixedFeeBasisId = this.resolvePopRateFixedFeeBasisId(popRate);
      if (fixedFeeBasisId != null) {
        payload.fixedFeeBasisId = fixedFeeBasisId;
      }
    }

    return payload;
  }

  savePopRateFixedFeeBasis(laborRate, popRate) {
    const fixedFeeBasisId = this.resolvePopRateFixedFeeBasisId(popRate);
    popRate.fixedFeeBasisId = fixedFeeBasisId;

    if (!fixedFeeBasisId) {
      return;
    }

    if (popRate.id < 0) {
      if (popRate.rate != null && popRate.rate !== '' && !popRate.suggestedRate) {
        this.updateLaborRate(laborRate, popRate, popRate.rate, true);
      }
      return;
    }

    let self = this;
    const payload = this.buildPopRateSavePayload(popRate);
    this.$http.post(
      this.$rootScope.apiHost + '/api/admin/contracts/' + this.contract.id + '/laborrates/' + laborRate.id + '/poprates/' + popRate.id,
      payload,
      { withCredentials: true }
    ).then(function () {
      self.$http.get(self.$rootScope.apiHost + '/api/admin/contracts/' + self.contract.id + '/laborrates/' + laborRate.id + '/poprates', { withCredentials: true })
        .then(function (answer) {
          laborRate.popRates = answer.data;
          self.initLaborRates();
        });
      self.toastr.success('Fixed fee basis updated for pop rate.', 'SUCCESS');
    }, function (failure) {
      popRate.selectedFixedFeeBasis = null;
      popRate.fixedFeeBasisId = null;
      self.toastr.error((failure.data && failure.data.message) || 'Could not update fixed fee basis.', 'ERROR');
    });
  }

  onPopRateBasisChange(laborRate, popRate) {
    if (!popRate) {
      return;
    }

    let self = this;
    this.$timeout(function () {
      if (popRate.selectedFixedFeeBasis) {
        popRate.fixedFeeBasisId = Number(popRate.selectedFixedFeeBasis.id);
      }
      self.savePopRateFixedFeeBasis(laborRate, popRate);
    });
  }

  formatFixedFeeDate(value) {
    if (!value) {
      return '—';
    }
    return moment(value).format('MMM DD, YYYY');
  }


  addLaborCategory(lcat) {
    let self = this;
    var modalInstance = this.$uibModal.open(createLaborCategoryModal);
    modalInstance.laborCategory = lcat;

    modalInstance.success = function (laborCategory) {
      self.$http.post(self.$rootScope.apiHost+"/api/admin/contracts/"+self.contract.id+"/laborcategories", laborCategory, {withCredentials: true}).then(function (success) {
        self.toastr.success("Update Success", "SUCCESS");
        self.laborCategoryFilterrefresh = !self.laborCategoryFilterrefresh;
        modalInstance.dismiss();
      }, function (failure) {
        self.toastr.error("Update Failed", failure.data.message);
      });
    };

    modalInstance.cancel = function () {
      modalInstance.dismiss();
    };
  }

  viewLaborCategory(lcat) {
    let self = this;
    var modalInstance = this.$uibModal.open(viewLaborCategoryModal);
    modalInstance.laborCategory = lcat;
    modalInstance.contractUrl = 'admin/contracts/' + this.contract.id;
    
    // Load company degrees for the degree selector
    this.$http.get(this.$rootScope.apiHost+"/api/admin/companies/1/degrees", {withCredentials: true}).then(function (success) {
      modalInstance.companyDegrees = success.data;
    });

    modalInstance.result.then(function(updatedLaborCategory) {
      // Refresh the labor categories table if needed
      self.laborCategoryFilterrefresh = !self.laborCategoryFilterrefresh;
    });
  }

  viewChargeCodes(laborRate, popRate) {
    var modalInstance = this.$uibModal.open(viewChargeCodesModal);
    modalInstance.chargeCodes = popRate.chargeCodes || [];
    modalInstance.laborRate = laborRate;
    modalInstance.popRate = popRate;
  }

  hasPaidInvoices(popRate) {
    if (!popRate || !this.paidInvoiceFlags) {
      return false;
    }
    const popRateId = popRate.id || 'unknown';
    return this.paidInvoiceFlags.get(popRateId) === true;
  }

  checkInvoicesBeforeEdit(laborRate, popRate, $event) {
    let self = this;
    const eventTarget = $event && $event.target ? $event.target : null;
    const popRateId = popRate.id || (laborRate.id + '_' + (popRate.periodOfPerformance ? popRate.periodOfPerformance.id : 'unknown'));
    
    // Check if this pop rate has paid invoices - if so, prevent editing immediately
    if (self.paidInvoiceFlags && self.paidInvoiceFlags.get(popRateId)) {
      if ($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
      self.toastr.error(
        'This labor rate has paid invoices associated with it. Changing the rate would cause synchronization issues between revenue and accounting systems. The rate cannot be modified.',
        'Cannot Modify Rate',
        { timeOut: 10000 }
      );
      return;
    }
    
    // Check if user already confirmed proceed for this popRate
    const flags = self.invoiceCheckFlags.get(popRateId);
    if (flags && flags.proceeded) {
      // User already confirmed, allow edit to proceed normally
      self.invoiceCheckFlags.delete(popRateId); // Clean up after use
      return; // Don't prevent - let xeditable handle the click
    }
    
    // Check if there are charge codes associated with this pop rate
    if (!popRate.chargeCodes || popRate.chargeCodes.length === 0) {
      // No charge codes, allow edit to proceed normally
      return; // Don't prevent - let xeditable handle the click
    }

    // Prevent xeditable from activating when there are charge codes
    // We'll check invoices and decide whether to allow editing
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }

    // Need to check invoices asynchronously
    // Store event target in separate map to avoid digest issues
    // Store it in a closure variable so we can access it even after flags are deleted
    const storedEventTarget = eventTarget;
    self.invoiceCheckFlags.set(popRateId, {
      proceeded: false,
      eventTarget: eventTarget
    });

    // Fetch invoices for each charge code
    const chargeCodes = popRate.chargeCodes || [];
    const promises = chargeCodes.map(function(chargeCode) {
      if (!chargeCode.id) {
        return self.$q.resolve([]); // Return empty array if no id
      }
      return self.$http.get(self.$rootScope.apiHost + '/api/admin/chargecodes/' + chargeCode.id + '/invoices', {withCredentials: true})
        .then(function(response) {
          // Return invoices with charge code info attached
          const invoices = response.data || [];
          return invoices.map(function(invoice) {
            return angular.extend({}, invoice, {
              chargeCodeId: chargeCode.id,
              chargeCodeName: chargeCode.name || 'N/A'
            });
          });
        })
        .catch(function(error) {
          console.error('Error fetching invoices for charge code ' + chargeCode.id + ':', error);
          return []; // Return empty array if fetch fails
        });
    });

    self.$q.all(promises).then(function(invoiceArrays) {
      // Flatten the array of arrays into a single array
      const allInvoices = invoiceArrays.reduce(function(acc, invoices) {
        return acc.concat(invoices);
      }, []);

      // Check if any invoices are paid
      const hasPaidInvoices = allInvoices.some(function(invoice) {
        return invoice.paid === true;
      });

      // If there are paid invoices, prevent editing and show error message
      if (hasPaidInvoices) {
        // Mark this pop rate as having paid invoices to prevent future edits
        self.paidInvoiceFlags.set(popRateId, true);
        
        // Clean up flags
        self.invoiceCheckFlags.delete(popRateId);
        
        // Use $timeout to ensure we're outside the current digest cycle
        self.$timeout(function() {
          // Use the stored event target from closure
          const targetToBlur = storedEventTarget;
          
          // Blur the xeditable button to prevent it from activating
          if (targetToBlur) {
            targetToBlur.blur();
            // Remove any focus from the element
            if (document.activeElement === targetToBlur) {
              targetToBlur.blur();
            }
          }
          
          // Simulate a click elsewhere to ensure xeditable doesn't activate
          self.$timeout(function() {
            var clickEvent = new MouseEvent('click', {
              view: window,
              bubbles: true,
              cancelable: true
            });
            document.body.dispatchEvent(clickEvent);
          }, 0);
        }, 0);
        
        // Show error message
        self.toastr.error(
          'This labor rate has paid invoices associated with it. Changing the rate would cause synchronization issues between revenue and accounting systems. The rate cannot be modified.',
          'Cannot Modify Rate',
          { timeOut: 10000 } // Show for 10 seconds since it's an important message
        );
        return; // Prevent editing - don't proceed with modal or edit activation
      }
      
      // Clear paid invoice flag if no paid invoices found (in case it was set before)
      self.paidInvoiceFlags.delete(popRateId);

      // Only open modal if there are invoices (but none are paid)
      if (allInvoices.length > 0) {
        // Use $timeout to defer modal opening until after current digest cycle
        self.$timeout(function() {
          const flags = self.invoiceCheckFlags.get(popRateId);
          const eventTarget = flags ? flags.eventTarget : null;
          
          // Blur the xeditable button that launched this
          if (eventTarget) {
            eventTarget.blur();
          }
          
          self.$timeout(function() {
            var clickEvent = new MouseEvent('click', {
              view: window,
              bubbles: true,
              cancelable: true
            });
            document.body.dispatchEvent(clickEvent);
          }, 0);

          var modalInstance = self.$uibModal.open(viewInvoicesModal);
          modalInstance.invoices = allInvoices;
          modalInstance.laborRate = laborRate;
          modalInstance.popRate = popRate;
          
          // Handle modal result
          modalInstance.result.then(function(result) {
            if (result === 'proceed') {
              // User chose to proceed - trigger xeditable directly
              self.$timeout(function() {
                const currentFlags = self.invoiceCheckFlags.get(popRateId);
                const currentEventTarget = currentFlags ? currentFlags.eventTarget : null;
                if (currentEventTarget) {
                  // Mark that user has proceeded
                  self.invoiceCheckFlags.set(popRateId, {
                    proceeded: true,
                    eventTarget: currentEventTarget
                  });
                  
                  // Use Angular's element to find and trigger xeditable
                  var $element = angular.element(currentEventTarget);
                  // The button itself has editable-number, so trigger click on it
                  $element.triggerHandler('click');
                  
                  // Clean up after a delay to allow xeditable to process
                  self.$timeout(function() {
                    self.invoiceCheckFlags.delete(popRateId);
                  }, 500);
                }
              }, 100);
            } else {
              // User cancelled - clean up
              self.invoiceCheckFlags.delete(popRateId);
            }
          }).catch(function() {
            // Modal was dismissed (cancel) - clean up
            self.invoiceCheckFlags.delete(popRateId);
          });
        }, 0);
      } else {
        // No invoices found - allow edit to proceed by triggering click again
        self.$timeout(function() {
          const flags = self.invoiceCheckFlags.get(popRateId);
          const eventTarget = flags ? flags.eventTarget : null;
          if (eventTarget) {
            var clickEvent = new MouseEvent('click', {
              view: window,
              bubbles: true,
              cancelable: true
            });
            eventTarget.dispatchEvent(clickEvent);
            self.invoiceCheckFlags.delete(popRateId);
          }
        }, 0);
      }
    });
  }



  addLaborRate(){
    let self = this;
    var modalInstance = this.$uibModal.open(laborRateModal);
    modalInstance.laborCategories = this.contract.laborCategories;
    modalInstance.contractId = this.contract.id;
    modalInstance.costBased = this.isCostBasedContract();
    modalInstance.fixedFeeBasisList = this.fixedFeeBasisList || [];
    modalInstance.selectedPeriodOfPerformance = this.getSelectedLaborRatePop();
    modalInstance.formatFixedFeeBasisOption = (basis) => this.formatFixedFeeBasisOption(basis);
    modalInstance.contract = this.contract;
    modalInstance.customer = this.selectedCustomer || (this.customers || []).find(function (customer) {
      return customer.id === self.contract.customerId;
    }) || null;

    modalInstance.success = function (laborRate) {
      if(self.isCostBasedContract()) {
        laborRate.directRate = true;
      }

      const basisByPopId = laborRate.popRateFixedFeeBasisByPopId || {};
      const createChargeCodeRequest = laborRate.createChargeCodeRequest || null;
      delete laborRate.createChargeCodeRequest;
      delete laborRate.popRateFixedFeeBasisByPopId;

      self.$http.post(self.$rootScope.apiHost+"/api/admin/contracts/"+laborRate.contractId+"/laborrates", laborRate, {withCredentials: true}).then(function (response) {
        const createdLaborRate = response.data;

        if (!self.isCostBasedContract()) {
          self.toastr.success("Update Success", "SUCCESS");
          self.loadContract();
          modalInstance.dismiss();
          return;
        }

        const popRateUpdates = (createdLaborRate.popRates || []).map(function (popRate) {
          const popId = popRate.periodOfPerformance && popRate.periodOfPerformance.id;
          const fixedFeeBasisId = popId ? basisByPopId[popId] : null;
          if (!fixedFeeBasisId || popRate.id <= 0) {
            return self.$q.resolve();
          }

          return self.$http.post(
            self.$rootScope.apiHost + '/api/admin/contracts/' + self.contract.id + '/laborrates/' + createdLaborRate.id + '/poprates/' + popRate.id,
            {
              rate: popRate.rate,
              periodOfPerformance: { id: popId },
              fixedFeeBasisId: Number(fixedFeeBasisId)
            },
            { withCredentials: true }
          );
        });

        return self.$q.all(popRateUpdates).then(function () {
          if (!createChargeCodeRequest) {
            self.toastr.success("Update Success", "SUCCESS");
            self.loadContract();
            modalInstance.dismiss();
            return;
          }

          return self.createChargeCodeForLaborRate(createdLaborRate, createChargeCodeRequest).then(function () {
            self.toastr.success("Labor rate and charge code created", "SUCCESS");
            self.loadContract();
            modalInstance.dismiss();
          }, function (failure) {
            self.toastr.warning(
              (failure.data && failure.data.message)
                ? failure.data.message
                : 'Labor rate was created, but the charge code could not be created.',
              'PARTIAL SUCCESS'
            );
            self.loadContract();
            modalInstance.dismiss();
          });
        });
      }, function (failure) {
        self.toastr.error("Update Failed", failure.data && failure.data.message ? failure.data.message : 'Could not add labor rate.');
      });
    };

    modalInstance.cancel = function () {
      modalInstance.dismiss();
    };
  }

  createChargeCodeForLaborRate(createdLaborRate, request) {
    const popRate = (createdLaborRate.popRates || []).find(function (rate) {
      return rate.periodOfPerformance && rate.periodOfPerformance.id === request.periodOfPerformanceId;
    });

    if (!popRate || !popRate.id) {
      return this.$q.reject({ data: { message: 'Could not find the option-year pop rate for charge code creation.' } });
    }

    const pop = (popRate.periodOfPerformance) || this.getSelectedLaborRatePop() || {};
    const payload = {
      name: request.name,
      description: request.description,
      leaveType: false,
      billable: true,
      payable: true,
      payrollCostCategory: 'DIRECT',
      taskOrder: { id: request.projectId },
      popRate: { id: popRate.id },
      effectiveDate: pop.startDate ? moment(pop.startDate).format('YYYY-MM-DD') : null,
      expirationDate: pop.endDate ? moment(pop.endDate).format('YYYY-MM-DD') : null,
      users: [request.userId]
    };

    return this.$http.post(this.$rootScope.apiHost + '/api/admin/chargecodes', payload, { withCredentials: true });
  }

  createLaborRate() {
    this.addLaborRate();
  }


  storeOriginalFixedFeeBasisField(row, field) {
    const key = row.id + ':' + field;
    this.originalFixedFeeBasisFields.set(key, row[field]);
    return true;
  }

  fixedFeeBasisFieldUnchanged(field, original, current) {
    if (field === 'modLabel' || field === 'effectiveDate') {
      return String(original || '').trim() === String(current || '').trim();
    }

    if (original === current) {
      return true;
    }
    if (Number(original) === Number(current)) {
      return true;
    }
    if ((original == null || original === '') && (current == null || current === '')) {
      return true;
    }
    return false;
  }

  updateFixedFeeBasisField(row, field) {
    const key = row.id + ':' + field;
    const original = this.originalFixedFeeBasisFields.has(key)
      ? this.originalFixedFeeBasisFields.get(key)
      : row[field];
    this.originalFixedFeeBasisFields.delete(key);

    if (this.fixedFeeBasisFieldUnchanged(field, original, row[field])) {
      return;
    }

    this.updateFixedFeeBasisEntry(row);
  }

  updateFixedFeeBasisEntry(fixedFeeBasisEntry) {
    let self = this;
    this.$http.put(this.contractUrl + '/fixedfeebasis/' + fixedFeeBasisEntry.id, fixedFeeBasisEntry, { withCredentials: true })
      .then(function () {
        self.toastr.success('Successfully updated fixed fee basis entry.', 'SUCCESS');
        self.loadFixedFeeBasis();
      })
      .catch((err) => {
        const message = (err.data && err.data.message) || 'Could not update fixed fee basis entry.';
        console.error('Could not update fixed fee basis entry:', err);
        self.toastr.error(message, 'ERROR');
      });
  }



  updateLaborRateName(laborRate, newName) {

    console.log('updateLaborRateName', laborRate, newName);
    // Don't fire REST request if value didn't change
    const originalName = laborRate.name || '';
    const trimmedNewName = (newName || '').toString().trim();
    const trimmedOriginalName = originalName.toString().trim();
    
    if (trimmedOriginalName === trimmedNewName) {
      return;
    }
    
    let obj = {
      name : newName
    }

    let self = this;
    this.$http
      .patch(this.contractUrl + '/laborrates/'+laborRate.id, obj, { withCredentials: true })
      .then(function (success) {
        self.toastr.success('Successfully updated labor rate name.', 'SUCCESS');
      })
      .catch((err) => {
        console.error('Could not update labor rate name:', err);
        this.toastr.error('Could not update labor rate name.', 'ERROR');
      });

  }

  isCostBasedContract() {
    if(this.contract && this.contract.contractType) {
      return this.contract.contractType === 'CPFF' || this.contract.contractType === 'CPAF';
    } else {
      return false;
    }
  }

  deleteLaborCategory(lcat) {
    let self = this;
    
    // Check if there are any labor rates associated with this labor category
    if (this.contract && this.contract.laborRates) {
      const associatedLaborRates = this.contract.laborRates.filter(function(laborRate) {
        return laborRate.laborCategory && laborRate.laborCategory.id === lcat.id;
      });
      
      if (associatedLaborRates.length > 0) {
        this.toastr.error(
          `Cannot delete labor category "${lcat.name}" because it has ${associatedLaborRates.length} associated labor rate(s). Please remove or reassign the labor rates first.`,
          'Cannot Delete Labor Category',
          { timeOut: 8000 }
        );
        return;
      }
    }
    
    this.$http
      .delete(this.contractUrl + '/laborcategories/'+lcat.id, { withCredentials: true })
      .then(function (success) {
        self.toastr.success('Successfully Deleted Labor Category.', 'SUCCESS');
        self.laborCategoryFilterrefresh = !self.laborCategoryFilterrefresh;
      })
      .catch((err) => {
        console.error('Could not delete labor category:', err);
        if (err.status === 409) {
          self.toastr.error(`Cannot delete labor category "${lcat.name}" because it has associated labor rates.`, 'ERROR');
        } else {
          self.toastr.error('Unable to Delete Labor Category.', 'ERROR');
        }
      });
  }



  getRateForPop(laborRate, pop) {
    let rate = 0;
    laborRate.popRates.forEach(function(popRate) {
      if(popRate.periodOfPerformance.id === pop.id) {
        rate = popRate.rate;
      }
    });
    return rate;
  }

  calculateFringe(laborRate, pop) {
    return this.getEffectiveDLRate(laborRate, pop) * (pop.fringeRate/100);
  }

  getFringeSubtotal(laborRate, pop) {
    return this.calculateFringe(laborRate, pop) + this.getEffectiveDLRate(laborRate,pop);
  }

  calculateOverhead(laborRate, pop) {
    return this.getFringeSubtotal(laborRate, pop) * (pop.overheadRate/100);
  }

  calculateOverheadSubtotal(laborRate, pop) {
    return this.calculateOverhead(laborRate, pop) + this.getFringeSubtotal(laborRate, pop);
  }

  calculateGeneralAdministrative(laborRate, pop) {
    return this.calculateOverheadSubtotal(laborRate, pop) * (pop.generalAdministrativeRate/100);
  }

  calculateFullyBurdenedRate(laborRate, pop) {
    return this.calculateGeneralAdministrative(laborRate, pop) + this.calculateOverheadSubtotal(laborRate, pop);
  }

  getFixedFee(laborRate, pop) {
    return this.calculateFullyBurdenedRate(laborRate, pop) * (this.contract.contractFeePercentage/100);
  }

  getMaxRate(laborRate, pop) {
    return this.calculateFullyBurdenedRate(laborRate, pop) * 1.20;
  }

  getRateWithFee(laborRate, pop) {
    return this.getFixedFee(laborRate, pop) + this.calculateFullyBurdenedRate(laborRate,pop);
  }

  getCompositeGCY(pop) {
    let contractStartPeriod = moment(pop.startDate);
    let contractEndPeriod = moment(pop.endDate);
    let contractPeriodLength = Math.round(contractEndPeriod.diff(contractStartPeriod, 'MONTHS', true));

    let contractorFiscalYearStart = moment( new Date(contractStartPeriod.year()+1, 0, 1));
    let monthsInPriorYear = contractorFiscalYearStart.diff(contractStartPeriod, 'MONTHS');

    return (monthsInPriorYear/contractPeriodLength) * 100;
  }

  getCCFY(weightedRate, pop) {
    return weightedRate * (this.getCompositeGCY(pop) / 100);
  }

  getNCFY(laborRate, pop) {
    let rateWithEscalation = this.getRateForPop(laborRate, pop) + (this.getRateForPop(laborRate, pop) * (pop.laborEscalationRate / 100) );
    return rateWithEscalation * ( (100 - this.getCompositeGCY(pop)) / 100);
  }

  getEffectiveDLRate(laborRate, pop) {
    return this.getCCFY(laborRate, pop) + this.getNCFY(laborRate, pop);
  }

  createProject() {
    const modalInstance = this.$uibModal.open({
      template: createProjectModal.template,
      controller: createProjectModal.controller,
      controllerAs: '$ctrl',
      size: 'lg',
      windowClass: "hmodal-info animated zoomIn",
      resolve: {
        resolvedContractId: () => this.contract ? this.contract.id : null,
        resolvedContracts: () => this.contracts || []
      }
    });

    modalInstance.result.then((project) => {
      this.toastr.success("Your Project Was Created Successfully!", "Project Created");
      this.$state.go("admin.project-details", {'projectId': project.id});
    }).catch(() => {
      // Modal dismissed
    });
  }

  convertLcatToLaborRate() {
    this.showConvertLcatDialog();
  }

  deleteLaborRate(laborRate) {
    let self = this;

    if (!this.canDeleteLaborRate(laborRate)) {
      this.toastr.warning(this.getLaborRateDeleteBlockedMessage(laborRate), 'WARNING');
      return;
    }

    if (laborRate.deleteRequiresChargeCodeConfirmation) {
      const chargeCodeNames = (laborRate.chargeCodesToDelete || []).join(', ');
      const modalInstance = this.$uibModal.open(confirmModal);
      modalInstance.title = 'Delete Labor Rate';
      modalInstance.subject = laborRate.name;
      modalInstance.message = 'Deleting this labor rate will also permanently delete the associated charge code'
        + ((laborRate.chargeCodesToDelete || []).length > 1 ? 's' : '')
        + ': ' + chargeCodeNames + '. Continue?';

      modalInstance.yes = function () {
        modalInstance.dismiss();
        self.performDeleteLaborRate(laborRate);
      };

      modalInstance.no = function () {
        modalInstance.dismiss();
      };
      return;
    }

    this.performDeleteLaborRate(laborRate);
  }

  performDeleteLaborRate(laborRate) {
    let self = this;

    this.$http
      .delete(this.contractUrl + '/laborrates/' + laborRate.id, { withCredentials: true })
      .then(function () {
        self.toastr.success('Successfully deleted labor rate.', 'SUCCESS');
        _.remove(self.contract.laborRates, function (lr) {
          return laborRate.id === lr.id;
        });
      })
      .catch((err) => {
        console.error('Could not delete labor rate:', err);
        const message = err.data && err.data.message ? err.data.message : 'Could not delete labor rate.';
        self.toastr.error(message, 'ERROR');
      });
  }

  availablePopRates() {
    let self = this;
    let availablePopRates = [];
    self.contract.laborRates.forEach(function (laborRate) {
      laborRate.popRates.forEach(function (popRate) {
        if(popRate.id > 0) {
          popRate.name = laborRate.name + '-' + popRate.periodOfPerformance.name + ' (' + popRate.rate + ')';
          availablePopRates.push(popRate);
        }
      });
    });

    return availablePopRates;
  }

  associateChargeCodeToPopRate(chargeCode, rate) {
    let self = this;
    if(chargeCode.rate !== rate.rate) {
      self.toastr.error('Rates are not the same.', 'ERROR');

      return;
    } else {
      chargeCode.popRate = rate;
    }

    this.$http.put(this.$rootScope.apiHost+"/api/admin/chargecodes/"+chargeCode.id+"/poprate/"+rate.id, {}, {withCredentials: true}).then(function (success) {
      self.toastr.success('Successfully associated pop rate.', 'SUCCESS');
      chargeCode.popRate = rate;
    })
    .catch((err) => {
      console.error('Could not associate pop rate:', err);
      self.toastr.error('Could not associate pop rate.', 'ERROR');
      chargeCode.popRate = undefined;
    });
  }

  reccomendAssociatedPopRate(chargeCode) {
    let self = this;
    let reccomendedPopRate = undefined;

    self.contract.laborRates.forEach(function (laborRate) {
      laborRate.popRates.forEach(function (popRate) {
        if(popRate && popRate.id > 0) {

          let sameLcat = chargeCode.lcat.id === laborRate.laborCategory.id
          let sameRate = chargeCode.rate === popRate.rate;

          if(sameLcat && sameRate) {
            popRate.name = laborRate.name + '-' + popRate.periodOfPerformance.name + ' (' + popRate.rate + ')';
            reccomendedPopRate = popRate;
          }
        }
      });
    });

    return reccomendedPopRate;

  }


  showConvertLcatDialog() {
    let modalTemplate = String.raw`
    <style>
      .modal-xl {
        width: 1200px;
      }

      .convert-lcat-modal {
        .convert-lcat-info {
          font-size: 16px;
        }
        .associated-data {
          display: flex;

          margin-top: 25px;

          div {
            flex: 1;
          }
          div:nth-child(1) {
            margin-right: 50px;
          }
        }

        .lcat-table-header {
          font-size: 16px;
          margin-bottom: 10px;
        }

        .lcat-table {
          .lcat-row {
            cursor: pointer;

            &:hover td {
              background-color: lighten(@color-navy-blue, 60%);
            }

            &.active td {
              background-color: #98afc6;
              color: #FFFFFF;
            }
          }
        }

        .table-responsive {
          table.target-lcat-table {
            max-height: 255px;
          }
          table.charge-code-table,
          table.labor-rate-table {
            max-height: 195px;
          }
        }
      }
    </style>
    <div class="convert-lcat-modal">
      <div class="modal-content">
        <div class="modal-header small">
          <h4 class="modal-title">Convert to Labor Rate - {{selectedLcat.name}} ({{selectedLcat.shortName}})</h4>
        </div>
        <div class="modal-body">
          <div class="convert-lcat-info m-t-lg">
            <div>
              Current Associated Data
            </div>
          </div>
          <div class="associated-data m-l-md">
            <div>
              <div class="lcat-table-header">Charge Codes ({{ selectedLcat.chargeCodes.length || 0 }})</div>
              <div class="table-responsive">
                <table
                  class="charge-code-table table table-bordered toggle-arrow-tiny lcat-table"
                >
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th class="pop-column">Period of Perf</th>
                      <th class="pop-active-column">Active</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      ng-repeat="chargeCode in selectedLcat.chargeCodes"
                      class="lcat-row"
                      foo-repeat-done
                    >
                      <td>
                        {{ chargeCode.name }}
                      </td>
                      <td>
                        {{ chargeCode.periodOfPerformance.name }}
                      </td>
                      <td>
                        {{ chargeCode.periodOfPerformance.active }}
                      </td>
                    </tr>
                    <tr ng-if="!selectedLcat.chargeCodes || selectedLcat.chargeCodes.length === 0">
                      <td colspan="3">
                        No associated charge codes
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div class="lcat-table-header">Labor Rates ({{ selectedLcatLaborRates.length || 0 }})</div>
              <div class="table-responsive">
                <table
                  class="labor-rate-table table table-bordered toggle-arrow-tiny lcat-table"
                >
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th class="pops-column">Periods of Perf</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      ng-repeat="laborRate in selectedLcatLaborRates"
                      class="lcat-row"
                      foo-repeat-done
                    >
                      <td>
                        {{ laborRate.name }}
                      </td>
                      <td>
                        {{ laborRate.pops }}
                      </td>
                    </tr>
                    <tr ng-if="!selectedLcatLaborRates || selectedLcatLaborRates.length === 0">
                      <td colspan="2">
                        No associated labor rates
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="">
            <div class="convert-lcat-info m-t-lg">
              <div>
                Select a Labor Category to associate the new Labor Rate and all associated data
              </div>
            </div>
            <div class="target-charge-code m-t-lg m-l-md">
              <div class="row">
                <div class="col-md-4 m-b-xs">
                  <input
                    ng-model="targetLcatFilter"
                    class="col-md-4 form-control ng-pristine ng-untouched ng-valid ng-empty"
                    type="text"
                    placeholder="Filter"
                  >
                </div>
              </div>
              <div class="table-responsive">
                <table
                  id=""
                  class="footable target-lcat-table table table-bordered toggle-arrow-tiny lcat-table"
                  data-page-size="10000"
                  data-filter=#filter
                >
                  <thead>
                  <tr>
                    <th>Abbreviation</th>
                    <th>Name</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                    ng-repeat="lcat in filteredLcats"
                    ng-class="{'active': lcat.id === targetLcat.id}"
                    class="lcat-row"
                    foo-repeat-done
                    ng-click="selectTargetLcat(lcat)"
                  >
                    <td>
                      {{lcat.shortName}}
                    </td>
                    <td>
                      {{lcat.name}}
                    </td>
                  </tr>
                  <tr ng-if="filteredLcats.length === 0">
                    <td colspan="2">
                      No labor categories
                    </td>
                  </tr>
                  </tbody>
                  <!-- <tfoot ng-hide="targetLaborCategories.length <= 10">
                    <tr>
                      <td colspan="5">
                        <ul class="pagination pull-right"></ul>
                      </td>
                    </tr>
                  </tfoot> -->
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            class="btn btn-default"
            ng-click="cancel()"
          >
            Cancel
          </button>
          <button
            class="btn btn-primary"
            ng-click="submitConvertRequest()"
            ng-disabled="!targetLcat.id || saving"
          >
            Convert
          </button>
        </div>
      </div>
    </div>
    `

    const self = this
    let modalInstance = self.$uibModal.open({
      template: modalTemplate,
      animation: true,
      size: 'xl',
      windowClass: 'modal-test',
      windowTopClass: 'modal-test',
      controller: ['$rootScope', '$scope', '$uibModalInstance', '$http', 'toastr', function (
        $rootScope, $scope, $uibModalInstance, $http, toastr) {
        "ngInject";

        this.toastr = toastr

        $scope.cancel = () => {
          $uibModalInstance.dismiss('cancel')
        }

        $scope.selectedLcat = $uibModalInstance.selectedLcat
        $scope.selectedLcatLaborRates = $uibModalInstance.selectedLcatLaborRates
        $scope.contract = $uibModalInstance.contract

        $scope.targetLcat = {}
        $scope.targetLaborCategories = []
        $scope.targetLcatFilter = ''
        $scope.filteredLcats = $scope.targetLaborCategories
        $scope.saving = false

        $scope.selectTargetLcat = (lcat) => $scope.targetLcat = lcat

        $scope.submitConvertRequest = () => {
          console.log('submitConvertRequest()', $scope.selectedLcat, $scope.targetLcat)
          $scope.saving = true

          $http.post(`${$rootScope.apiHost}/api/admin/contracts/labor-category/convert`, {
            laborCategoryId: $scope.selectedLcat.id,
            destLaborCategoryId: $scope.targetLcat.id
          }, { withCredentials: true }).then((res) => {
              $uibModalInstance.success()
          }, (err) => {
            console.log('error!', err)
            $uibModalInstance.close()
            this.toastr.error("Could not convert labor category.", "ERROR")
          }, () => {
            $scope.saving = false
          })
        }

        $scope.$watch(() => $scope.contract, (newVal) => {
          $scope.targetLaborCategories = newVal.laborCategories.filter(lc => lc.id !== $scope.selectedLcat.id)
        }, true)

        $scope.$watch(() => $scope.targetLcatFilter, (newVal) => {
          const filterStr = newVal+''.trim()
          if (!filterStr || filterStr.length === 0) {
            $scope.filteredLcats = $scope.targetLaborCategories
          } else {
            $scope.filteredLcats = $scope.targetLaborCategories
              .filter(lc => lc.name.toLowerCase().indexOf(filterStr.toLowerCase()) !== -1 || lc.shortName.toLowerCase().indexOf(filterStr.toLowerCase()) !== -1)
          }

        })
      }]
    })

    modalInstance.selectedLcat = self.selectedLcat
    modalInstance.selectedLcatLaborRates = self.selectedLcatLaborRates
    modalInstance.contract = self.contract

    modalInstance.success = function () {
      self.toastr.success('Successfully converted to labor rate!', 'SUCCESS')
      self.loadContract();
      modalInstance.dismiss();
    };

    return modalInstance
  }
}

export default ContractDetailsController;

/* Helpers */

const monthFormatter = Intl.DateTimeFormat(undefined, { year: 'numeric', month: 'long' });
function getMonth() {
  return monthFormatter.format(new Date());
}

const usdFormatter = Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' });
function formatDollars(value) {
  if (typeof value !== 'number') {
    return undefined;
  }
  return usdFormatter.format(value);
}

function localDate(s) {
  if (!s || s === null || s === undefined) {
    return null;
  }
  const [year, month, day] = s.split('-').map((n) => parseInt(n));
  return new Date(year, month - 1, day);
}



// WEBPACK FOOTER //
// ./client/pages/admin/contract-details/contract-details.controller.js